export const stakingVaultData = [
  {
    stakeAddresses: [
      '0x21Db1777Dd95749A849d9e244136E72bd93082Ea',
      '0x9F97b34161686d60ADB955ed63A2FC0b2eC0a2a9',
      '0xFC1fC3a05EcdF6B3845391aB5CF6a75aeDef7CeA',
      '0x7da4E8Ab0bB29a6772b6231b01ea372994c2A49A',
      '0x9a8294566960Ab244d78D266FFe0f284cDf728F1',
    ],
    orderedEndBlocks: [13194271, 13593543, 14195725, 15380452, 20165180],
    stakeInfos: [
      {
        _id: '619853381a92460407c2cd09',
        stakeAddress: '0x21Db1777Dd95749A849d9e244136E72bd93082Ea',
        name: 'TON #5',
        startBlock: 12991362,
        endBlock: 13194271,
        balance: '56403030000000000000000',
        totalRewardAmount: '7232942337778155605035',
        claimRewardAmount: '7220416683495850348078',
        memo: '1 month',
      },
      {
        _id: '619853381a92460407c2cd0a',
        stakeAddress: '0x9F97b34161686d60ADB955ed63A2FC0b2eC0a2a9',
        name: 'TON #4',
        startBlock: 12991362,
        endBlock: 13593543,
        balance: '351067770000000000000000',
        totalRewardAmount: '135535912103158129083109',
        claimRewardAmount: '101079751623651869169094',
        memo: '3 months',
      },
      {
        _id: '619853381a92460407c2cd0b',
        stakeAddress: '0xFC1fC3a05EcdF6B3845391aB5CF6a75aeDef7CeA',
        name: 'TON #3',
        startBlock: 12991362,
        endBlock: 14195725,
        balance: '203511990000000000000000',
        totalRewardAmount: '170113945002837827751005',
        claimRewardAmount: '36591286727911139963932',
        memo: '6 months',
      },
      {
        _id: '619853381a92460407c2cd0c',
        stakeAddress: '0x7da4E8Ab0bB29a6772b6231b01ea372994c2A49A',
        name: 'TON #2',
        startBlock: 12991362,
        endBlock: 15380452,
        balance: '304759610000000000000000',
        totalRewardAmount: '551413315976537436570869',
        claimRewardAmount: '59406125223381409017012',
        memo: '1 year',
      },
      {
        _id: '619853381a92460407c2cd0d',
        stakeAddress: '0x9a8294566960Ab244d78D266FFe0f284cDf728F1',
        name: 'TON #1',
        startBlock: 12991362,
        endBlock: 20165180,
        balance: '1731048510000000000000000',
        totalRewardAmount: '11135703884579688444731428',
        claimRewardAmount: '552619346768889416228415',
        memo: '3 years',
      },
    ],
    stakeEndBlockTotal: [
      {
        _id: '619853381a92460407c2cd0e',
        block: 13194271,
        stakedTotal: '2646790910000000000000000',
      },
      {
        _id: '619853381a92460407c2cd0f',
        block: 13593543,
        stakedTotal: '2590387880000000000000000',
      },
      {
        _id: '619853381a92460407c2cd10',
        block: 14195725,
        stakedTotal: '2239320110000000000000000',
      },
      {
        _id: '619853381a92460407c2cd11',
        block: 15380452,
        stakedTotal: '2035808120000000000000000',
      },
      {
        _id: '619853381a92460407c2cd12',
        block: 20165180,
        stakedTotal: '1731048510000000000000000',
      },
    ],
    expectedStakeEndBlockTotal: [
      {
        _id: '611132688f95bcaff225630a',
        block: 13194271,
        stakedTotalString: '2646790910000000000000000',
      },
      {
        _id: '611132688f95bcaff225630b',
        block: 13593543,
        stakedTotalString: '2590387880000000000000000',
      },
      {
        _id: '611132688f95bcaff225630c',
        block: 14195725,
        stakedTotalString: '2239320110000000000000000',
      },
      {
        _id: '611132688f95bcaff225630d',
        block: 15380452,
        stakedTotalString: '2035808120000000000000000',
      },
      {
        _id: '611132688f95bcaff225630e',
        block: 20165180,
        stakedTotalString: '1731048510000000000000000',
      },
    ],
    vault: '0xf04f6a6d6115d8400d18eca99bdee67abb498a7b',
    paytoken: '0x2be5e8c109e2197D077D13A82dAead6a9b3433C5',
    cap: 1.2e25,
    saleStartBlock: 12899725,
    stakeStartBlock: 12991362,
    stakeEndBlock: 20165180,
    blockTotalReward: 1672749434122806000,
    saleClosed: true,
    stakeType: 0,
    fetchRequest: false,
    fetchRequestBlock: 12991489,
    fetchedBlock: 13649090,
    chainId: 1,
    blockNumber: 12880637,
    transactionHash:
      '0xf98376c69d004e9577f0eb5752e674848ea8696dc18a6740a1ea5070c515bfae',
    defiAddr: '0x0000000000000000000000000000000000000000',
    expectedCalculatedBlock: 12991326,
  },
];
export const tosMiningDB = [
  {
    stakeContract: '0x9a8294566960ab244d78d266ffe0f284cdf728f1',
    vault: '0xf04f6a6d6115d8400d18eca99bdee67abb498a7b',
    phase: 1,
    stakeType: 0,
    paytoken: '0x2be5e8c109e2197D077D13A82dAead6a9b3433C5',
    name: 'TON #1',
    saleStartBlock: 12899725,
    startBlock: 12991362,
    endBlock: 20165180,
    saleClosed: true,
    totalStakers: 64,
    totalStakedAmount: 1.73104851e24,
    totalStakedAmountString: '1731048510000000000000000',
    fetchRequest: false,
    fetchRequestBlock: 12991240,
    fetchedBlock: 13645446,
    chainId: 1,
    blockNumber: 12880654,
    transactionHash:
      '0x722bce78b9ba7f37486a03bb7a58596fdf453f9cc88affb516d025ae54a71b29',
  },
  {
    stakeContract: '0x7da4e8ab0bb29a6772b6231b01ea372994c2a49a',
    vault: '0xf04f6a6d6115d8400d18eca99bdee67abb498a7b',
    phase: 1,
    stakeType: 0,
    paytoken: '0x2be5e8c109e2197D077D13A82dAead6a9b3433C5',
    name: 'TON #2',
    saleStartBlock: 12899725,
    startBlock: 12991362,
    endBlock: 15380452,
    saleClosed: true,
    totalStakers: 22,
    totalStakedAmount: 3.0475961e23,
    totalStakedAmountString: '304759610000000000000000',
    fetchRequest: false,
    fetchRequestBlock: 12991030,
    fetchedBlock: 13645446,
    chainId: 1,
    blockNumber: 12880653,
    transactionHash:
      '0x600d427a1b4457a53c3faa4a1c808671c129f1e08c69b1a1f1335682d1de4e03',
  },
  {
    stakeContract: '0xfc1fc3a05ecdf6b3845391ab5cf6a75aedef7cea',
    vault: '0xf04f6a6d6115d8400d18eca99bdee67abb498a7b',
    phase: 1,
    stakeType: 0,
    paytoken: '0x2be5e8c109e2197D077D13A82dAead6a9b3433C5',
    name: 'TON #3',
    saleStartBlock: 12899725,
    startBlock: 12991362,
    endBlock: 14195725,
    saleClosed: true,
    totalStakers: 15,
    totalStakedAmount: 2.0351199e23,
    totalStakedAmountString: '203511990000000000000000',
    fetchRequest: false,
    fetchRequestBlock: 12989996,
    fetchedBlock: 13645446,
    chainId: 1,
    blockNumber: 12880651,
    transactionHash:
      '0x614d498d55e79a49dcc7341ac2bdd242f68c7c5cbd930e1f1aa82ee7e136c98b',
  },
  {
    stakeContract: '0x9f97b34161686d60adb955ed63a2fc0b2ec0a2a9',
    vault: '0xf04f6a6d6115d8400d18eca99bdee67abb498a7b',
    phase: 1,
    stakeType: 0,
    paytoken: '0x2be5e8c109e2197D077D13A82dAead6a9b3433C5',
    name: 'TON #4',
    saleStartBlock: 12899725,
    startBlock: 12991362,
    endBlock: 13593543,
    saleClosed: true,
    totalStakers: 16,
    totalStakedAmount: 3.5106777e23,
    totalStakedAmountString: '351067770000000000000000',
    fetchRequest: false,
    fetchRequestBlock: 12991326,
    fetchedBlock: 13645446,
    chainId: 1,
    blockNumber: 12880650,
    transactionHash:
      '0x16cf58931f7eed644e997f73ba349e11e9d63bfbcbf2966d3858054a29191432',
  },
  {
    stakeContract: '0x21db1777dd95749a849d9e244136e72bd93082ea',
    vault: '0xf04f6a6d6115d8400d18eca99bdee67abb498a7b',
    phase: 1,
    stakeType: 0,
    paytoken: '0x2be5e8c109e2197D077D13A82dAead6a9b3433C5',
    name: 'TON #5',
    saleStartBlock: 12899725,
    startBlock: 12991362,
    endBlock: 13194271,
    saleClosed: true,
    totalStakers: 16,
    totalStakedAmount: 5.640303e22,
    totalStakedAmountString: '56403030000000000000000',
    fetchRequest: false,
    fetchRequestBlock: 12990979,
    fetchedBlock: 13645446,
    chainId: 1,
    blockNumber: 12880649,
    transactionHash:
      '0x4366311101eed767339c5cbf551410aeb3b3d8439d2b9e6716288ad44135acd5',
  },
];

export const starterDB = {
  success: true,
  message: '',
  query: {
    chainId: '1',
  },
  counts: 3,
  page: 1,
  pagesize: 100,
  sort: -1,
  datas: [
    {
      chainId: 1,
      name: 'DOOR OPEN',
      description:
        'The DOOROPEN project aims to create content entirely owned by the company using virtual humans to resolve human risks and complex copyright issues in the creation of content in the NFT market. With DOOROPEN’s AI-based realistic virtual humans, DOOROPEN plans to create never-before-seen genres of interactive content this year.',
      image: '',
      adminAddress: '0x8c595DA827F4182bC0E3917BccA8e654DF8223E1',
      website: 'https://dooropen.space/',
      telegram: 'https://t.me/Dooropen_Space',
      medium: '',
      twitter: 'https://twitter.com/dooropen_space',
      discord: 'https://discord.gg/XxgCx2W2Bp',
      tokenName: 'DOC',
      tokenAddress: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
      tokenSymbol: 'DOC',
      tokenSymbolImage:
        'https://tonstarter-symbols.s3.ap-northeast-2.amazonaws.com/doc-symbol%403x.png',
      tokenFundRaisingTargetAmount: '10000000',
      tokenFundingRecipient: '0x642C239C9BEF6574FE3dc64B82dED55A30d0dc25',
      projectFundingTokenRatio: 10550,
      projectTokenRatio: 20,
      saleContractAddress: '0xBef737D725993847c345647ebA096500FdAE71c6',
      vestingContractAddress: '0xBef737D725993847c345647ebA096500FdAE71c6',
      snapshot: 1635148740,
      startAddWhiteTime: 1635148800,
      endAddWhiteTime: 1635321599,
      startExclusiveTime: 1635321600,
      endExclusiveTime: 1635494399,
      startDepositTime: 1635494400,
      endDepositTime: 1636099199,
      startOpenSaleTime: 1636099199,
      endOpenSaleTime: 1636099199,
      startClaimTime: 1636099200,
      claimInterval: 2592000,
      claimPeriod: 6,
      position: 'active',
      production: 'production',
      del: false,
      tokenAllocationAmount: '25000000',
      fundingTokenType: 'TON',
    },
    {
      chainId: 1,
      name: 'Dragons of Midgard',
      description:
        'Playable NFT Collectible PVP game set in the medieval era in the kingdom of midgard. Dragons of midgard is crypto collectible P2E game which will allow users to play and earn in unique pvp battles with 30 species and 8 dragon territories to make the perfect gaming experience for the players. While dragon holders will be able to earn by playing dragons of midgard game.',
      image: '',
      adminAddress: 'DOM-TEST',
      website: 'https://dragonsofmidgard.com/',
      telegram: 'https://t.me/DragonsofMidgardOfficialKR',
      medium: '',
      twitter: 'https://twitter.com/dragons_midgard',
      discord: '',
      tokenName: 'Aura',
      tokenAddress: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
      tokenSymbol: 'AURA',
      tokenSymbolImage:
        'https://tonstarter-symbols.s3.ap-northeast-2.amazonaws.com/aura-logo-black-big.png',
      tokenAllocationAmount: '12000000',
      tokenFundRaisingTargetAmount: '12000',
      tokenFundingRecipient: 'DOM-TEST',
      projectFundingTokenRatio: 632,
      projectTokenRatio: 20,
      saleContractAddress: '0x3B75d3f628C29d357b484EA7d091faEd63419267',
      snapshot: 1639468740,
      startAddWhiteTime: 1639468800,
      endAddWhiteTime: 1639641599,
      startExclusiveTime: 1639641600,
      endExclusiveTime: 1639814399,
      startDepositTime: 1639814400,
      endDepositTime: 1640159999,
      startClaimTime: 1640160000,
      claimInterval: 2592000,
      claimPeriod: 6,
      position: 'active',
      production: 'production',
      del: false,
      fundingTokenType: 'TON',
      claimFirst: 50,
    },
    {
      chainId: 1,
      name: 'LYDA',
      description:
        '<p><span style="background-color: transparent; color: rgb(0, 0, 0);">LYDA is a “Social Token Platform” that transforms the unique value of specific fandoms into blockchain economics by measuring and realizing “social capital” within digital content creators’ fandoms.</span></p><p><br></p><p><span style="background-color: transparent; color: rgb(0, 0, 0);">For details, please check out&nbsp;LYDA Whitepaper with the following </span><a href="https://www.lyda.so/" rel="noopener noreferrer" target="_blank" style="background-color: transparent; color: rgb(0, 0, 0);"><strong>website</strong></a><span style="background-color: transparent; color: rgb(0, 0, 0);">.</span></p>',
      adminAddress: '0x70115ba3b49D60776AaA2976ADffB5CfABf31689',
      website: 'https://www.lyda.so/',
      telegram: 'https://t.me/lyda_official',
      medium: '',
      twitter: 'https://twitter.com/Lyda_official',
      discord: '',
      tokenName: 'LYDA',
      tokenAddress: '0xE1B0630D7649CdF503eABc2b6423227Be9605247',
      tokenSymbol: 'LYDA',
      tokenSymbolImage:
        'https://cdn.imweb.me/thumbnail/20220608/f32f048bccbad.jpg',
      tokenAllocationAmount: '1000000',
      fundingTokenType: 'TON',
      tokenFundRaisingTargetAmount: '5000',
      tokenFundingRecipient: '0x70115ba3b49D60776AaA2976ADffB5CfABf31689',
      projectFundingTokenRatio: 1,
      projectTokenRatio: 8.6,
      saleContractAddress: '0x3ba5c96665960ABD931858b8D80Ec80f53F2A09c',
      snapshot: 1655452800,
      startAddWhiteTime: 1655452801,
      endAddWhiteTime: 1655625600,
      startExclusiveTime: 1655625601,
      endExclusiveTime: 1655798400,
      startDepositTime: 1655798401,
      endDepositTime: 1656057600,
      startClaimTime: 1656057601,
      claimInterval: 2592000,
      claimPeriod: 6,
      claimFirst: 500000,
      position: 'upcoming',
      production: 'production',
      topSlideExposure: false,
      del: false,
      projectKey: '-N41hYw_sT6FbGGT97Tu',
      delistedData: {
        delistedTime: 0,
        reason: '',
        reasonType: '',
      },
      salePrice: '0.2',
    },
  ],
};

export const launchDB = {
  data: {
    '-N41hYw_sT6FbGGT97Tu': {
      description:
        '<p><span style="background-color: transparent; color: rgb(0, 0, 0);">LYDA is a “Social Token Platform” that transforms the unique value of specific fandoms into blockchain economics by measuring and realizing “social capital” within digital content creators’ fandoms.</span></p><p><br></p><p><span style="background-color: transparent; color: rgb(0, 0, 0);">For details, please check out&nbsp;LYDA Whitepaper with the following </span><a href="https://www.lyda.so/" rel="noopener noreferrer" target="_blank" style="background-color: transparent; color: rgb(0, 0, 0);"><strong>website</strong></a><span style="background-color: transparent; color: rgb(0, 0, 0);">.</span></p>',
      discord: '',
      isAllDeployed: false,
      isTokenDeployed: true,
      isTokenDeployedErr: false,
      medium: '',
      owner: '0x70115ba3b49D60776AaA2976ADffB5CfABf31689',
      ownerAddress: '0x70115ba3b49D60776AaA2976ADffB5CfABf31689',
      projectName: 'LYDA',
      projectTokenPrice: '8.60',
      sector: 'Social',
      telegram: 'https://t.me/lyda_official',
      tokenAddress: '0xE1B0630D7649CdF503eABc2b6423227Be9605247',
      tokenName: 'LYDA',
      tokenSymbol: 'LYDA',
      tokenSymbolImage:
        'https://cdn.imweb.me/thumbnail/20220608/f32f048bccbad.jpg',
      tosPrice: '2.74',
      totalSupply: '10000000',
      totalTokenAllocation: 10000000,
      twitter: 'https://twitter.com/Lyda_official',
      vaults: [
        {
          addressForReceiving: '0x70115ba3b49D60776AaA2976ADffB5CfABf31689',
          adminAddress: '0x70115ba3b49D60776AaA2976ADffB5CfABf31689',
          claim: [
            {
              claimRound: 1,
              claimTime: 1656057601,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 2,
              claimTime: 1658649601,
              claimTokenAllocation: 100000,
            },
            {
              claimRound: 3,
              claimTime: 1661241601,
              claimTokenAllocation: 100000,
            },
            {
              claimRound: 4,
              claimTime: 1663833601,
              claimTokenAllocation: 100000,
            },
            {
              claimRound: 5,
              claimTime: 1666425601,
              claimTokenAllocation: 100000,
            },
            {
              claimRound: 6,
              claimTime: 1669017601,
              claimTokenAllocation: 100000,
            },
          ],
          hardCap: '5000',
          index: 0,
          isDeployed: true,
          isDeployedErr: false,
          isMandatory: true,
          isSet: true,
          name: 'Public *',
          publicRound1: 1655625601,
          publicRound1Allocation: '700000',
          publicRound1End: 1655798400,
          publicRound2: 1655798401,
          publicRound2Allocation: '300000',
          publicRound2End: 1656057600,
          snapshot: 1655452800,
          stosTier: {
            fourTier: {
              allocatedToken: '385000',
              requiredStos: 6000,
            },
            oneTier: {
              allocatedToken: '42000',
              requiredStos: '600',
            },
            threeTier: {
              allocatedToken: '189000',
              requiredStos: 2200,
            },
            twoTier: {
              allocatedToken: '84000',
              requiredStos: 1200,
            },
          },
          tokenAllocationForLiquidity: 20,
          vaultAddress: '0x3ba5c96665960ABD931858b8D80Ec80f53F2A09c',
          vaultName: 'Public',
          vaultTokenAllocation: 1000000,
          vaultType: 'Public',
          whitelist: 1655452801,
          whitelistEnd: 1655625600,
        },
        {
          addressForReceiving: '0x70115ba3b49D60776AaA2976ADffB5CfABf31689',
          adminAddress: '0x70115ba3b49D60776AaA2976ADffB5CfABf31689',
          claim: [
            {
              claimRound: 1,
            },
          ],
          hardCap: '5000',
          index: 1,
          isDeployed: true,
          isDeployedErr: false,
          isMandatory: true,
          isSet: true,
          name: 'Initial Liquidity *',
          publicRound1: 1655539201,
          publicRound1Allocation: '700000',
          publicRound1End: 1655712000,
          publicRound2: 1655712001,
          publicRound2Allocation: '300000',
          publicRound2End: 1655971200,
          snapshot: 1655366400,
          stosTier: {
            fourTier: {
              allocatedToken: '385000',
              requiredStos: 6000,
            },
            oneTier: {
              allocatedToken: '42000',
              requiredStos: '600',
            },
            threeTier: {
              allocatedToken: '189000',
              requiredStos: 2200,
            },
            twoTier: {
              allocatedToken: '84000',
              requiredStos: 1200,
            },
          },
          tokenAllocationForLiquidity: 10,
          tosPrice: '4.05',
          vaultAddress: '0x620c86FD58E40f534545Aa433f49eF0271755E17',
          vaultName: 'Initial Liquidity',
          vaultTokenAllocation: 200000,
          vaultType: 'Initial Liquidity',
          whitelist: 1655366401,
          whitelistEnd: 1655539200,
        },
        {
          adminAddress: '0x70115ba3b49D60776AaA2976ADffB5CfABf31689',
          claim: [
            {
              claimRound: 1,
              claimTime: 1656057601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 2,
              claimTime: 1658649601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 3,
              claimTime: 1661241601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 4,
              claimTime: 1663833601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 5,
              claimTime: 1666425601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 6,
              claimTime: 1669017601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 7,
              claimTime: 1671609601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 8,
              claimTime: 1674201601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 9,
              claimTime: 1676793601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 10,
              claimTime: 1679385601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 11,
              claimTime: 1681977601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 12,
              claimTime: 1684569601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 13,
              claimTime: 1687161601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 14,
              claimTime: 1689753601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 15,
              claimTime: 1692345601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 16,
              claimTime: 1694937601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 17,
              claimTime: 1697529601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 18,
              claimTime: 1700121601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 19,
              claimTime: 1702713601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 20,
              claimTime: 1705305601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 21,
              claimTime: 1707897601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 22,
              claimTime: 1710489601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 23,
              claimTime: 1713081601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 24,
              claimTime: 1715673601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 25,
              claimTime: 1718265601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 26,
              claimTime: 1720857601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 27,
              claimTime: 1723449601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 28,
              claimTime: 1726041601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 29,
              claimTime: 1728633601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 30,
              claimTime: 1731225601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 31,
              claimTime: 1733817601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 32,
              claimTime: 1736409601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 33,
              claimTime: 1739001601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 34,
              claimTime: 1741593601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 35,
              claimTime: 1744185601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 36,
              claimTime: 1746777601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 37,
              claimTime: 1749369601,
              claimTokenAllocation: 3378.68,
            },
          ],
          index: 2,
          isDeployed: true,
          isDeployedErr: false,
          isMandatory: true,
          isSet: true,
          name: 'TON Staker *',
          vaultAddress: '0xf972657e6331e19ffcD1424a275215f7ab1A8df5',
          vaultName: 'TON Staker',
          vaultTokenAllocation: 125000,
          vaultType: 'TON Staker',
        },
        {
          adminAddress: '0x70115ba3b49D60776AaA2976ADffB5CfABf31689',
          claim: [
            {
              claimRound: 1,
              claimTime: 1656057601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 2,
              claimTime: 1658649601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 3,
              claimTime: 1661241601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 4,
              claimTime: 1663833601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 5,
              claimTime: 1666425601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 6,
              claimTime: 1669017601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 7,
              claimTime: 1671609601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 8,
              claimTime: 1674201601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 9,
              claimTime: 1676793601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 10,
              claimTime: 1679385601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 11,
              claimTime: 1681977601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 12,
              claimTime: 1684569601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 13,
              claimTime: 1687161601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 14,
              claimTime: 1689753601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 15,
              claimTime: 1692345601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 16,
              claimTime: 1694937601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 17,
              claimTime: 1697529601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 18,
              claimTime: 1700121601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 19,
              claimTime: 1702713601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 20,
              claimTime: 1705305601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 21,
              claimTime: 1707897601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 22,
              claimTime: 1710489601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 23,
              claimTime: 1713081601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 24,
              claimTime: 1715673601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 25,
              claimTime: 1718265601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 26,
              claimTime: 1720857601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 27,
              claimTime: 1723449601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 28,
              claimTime: 1726041601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 29,
              claimTime: 1728633601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 30,
              claimTime: 1731225601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 31,
              claimTime: 1733817601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 32,
              claimTime: 1736409601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 33,
              claimTime: 1739001601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 34,
              claimTime: 1741593601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 35,
              claimTime: 1744185601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 36,
              claimTime: 1746777601,
              claimTokenAllocation: 3378.37,
            },
            {
              claimRound: 37,
              claimTime: 1749369601,
              claimTokenAllocation: 3378.68,
            },
          ],
          index: 3,
          isDeployed: true,
          isDeployedErr: false,
          isMandatory: true,
          isSet: true,
          name: 'TOS Staker *',
          vaultAddress: '0xBb49719A0bC10bf9E8f0B5e2d0F74dEE830a0090',
          vaultName: 'TOS Staker',
          vaultTokenAllocation: 125000,
          vaultType: 'TOS Staker',
        },
        {
          adminAddress: '0x70115ba3b49D60776AaA2976ADffB5CfABf31689',
          claim: [
            {
              claimRound: 1,
              claimTime: 1656057601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 2,
              claimTime: 1658649601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 3,
              claimTime: 1661241601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 4,
              claimTime: 1663833601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 5,
              claimTime: 1666425601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 6,
              claimTime: 1669017601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 7,
              claimTime: 1671609601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 8,
              claimTime: 1674201601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 9,
              claimTime: 1676793601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 10,
              claimTime: 1679385601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 11,
              claimTime: 1681977601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 12,
              claimTime: 1684569601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 13,
              claimTime: 1687161601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 14,
              claimTime: 1689753601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 15,
              claimTime: 1692345601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 16,
              claimTime: 1694937601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 17,
              claimTime: 1697529601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 18,
              claimTime: 1700121601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 19,
              claimTime: 1702713601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 20,
              claimTime: 1705305601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 21,
              claimTime: 1707897601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 22,
              claimTime: 1710489601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 23,
              claimTime: 1713081601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 24,
              claimTime: 1715673601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 25,
              claimTime: 1718265601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 26,
              claimTime: 1720857601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 27,
              claimTime: 1723449601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 28,
              claimTime: 1726041601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 29,
              claimTime: 1728633601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 30,
              claimTime: 1731225601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 31,
              claimTime: 1733817601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 32,
              claimTime: 1736409601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 33,
              claimTime: 1739001601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 34,
              claimTime: 1741593601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 35,
              claimTime: 1744185601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 36,
              claimTime: 1746777601,
              claimTokenAllocation: 6756.75,
            },
            {
              claimRound: 37,
              claimTime: 1749369601,
              claimTokenAllocation: 6757,
            },
          ],
          index: 4,
          isDeployed: true,
          isDeployedErr: false,
          isMandatory: true,
          isSet: true,
          name: 'WTON-TOS LP Reward *',
          poolAddress: '0x516e1af7303a94f81e91e4ac29e20f4319d4ecaf',
          tokenPair: 'WTON-TOS',
          vaultAddress: '0xA31945830C5a6B225A81962a10E78D2e3793D72D',
          vaultName: 'WTON-TOS LP Reward',
          vaultTokenAllocation: 250000,
          vaultType: 'WTON-TOS LP Reward',
        },
        {
          adminAddress: '0x70115ba3b49D60776AaA2976ADffB5CfABf31689',
          claim: [
            {
              claimRound: 1,
              claimTime: 1656057601,
              claimTokenAllocation: 50000,
            },
            {
              claimRound: 2,
              claimTime: 1658649601,
              claimTokenAllocation: 50000,
            },
            {
              claimRound: 3,
              claimTime: 1661241601,
              claimTokenAllocation: 50000,
            },
            {
              claimRound: 4,
              claimTime: 1663833601,
              claimTokenAllocation: 50000,
            },
            {
              claimRound: 5,
              claimTime: 1666425601,
              claimTokenAllocation: 50000,
            },
            {
              claimRound: 6,
              claimTime: 1669017601,
              claimTokenAllocation: 50000,
            },
          ],
          index: 5,
          isDeployed: true,
          isDeployedErr: false,
          isMandatory: true,
          isSet: true,
          name: 'LYDA-TOS LP Reward *',
          vaultAddress: '0x45D08f522BF2b6455Fe7EeF0f4aDf865D76EaD08',
          vaultName: 'Liquidity Incentive',
          vaultTokenAllocation: 300000,
          vaultType: 'Liquidity Incentive',
        },
        {
          adminAddress: '0x70115ba3b49D60776AaA2976ADffB5CfABf31689',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 6,
          isDeployed: true,
          isDeployedErr: false,
          isMandatory: false,
          isSet: true,
          vaultAddress: '0xD99c6726F967cc2f177246Fc854b343fd8EefD94',
          vaultName: 'InitialContributor',
          vaultTokenAllocation: 500000,
          vaultType: 'DAO',
        },
        {
          adminAddress: '0x70115ba3b49D60776AaA2976ADffB5CfABf31689',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 7,
          isDeployed: true,
          isDeployedErr: false,
          isMandatory: false,
          isSet: true,
          vaultAddress: '0xC871B09130d2120965355444dd8aFB4cEa1B3dA7',
          vaultName: 'Reserve',
          vaultTokenAllocation: 300000,
          vaultType: 'DAO',
        },
        {
          adminAddress: '0x70115ba3b49D60776AaA2976ADffB5CfABf31689',
          claim: [
            {
              claimRound: 1,
              claimTime: 1671609601,
              claimTokenAllocation: 166666.66,
            },
            {
              claimRound: 2,
              claimTime: 1674201601,
              claimTokenAllocation: 166666.66,
            },
            {
              claimRound: 3,
              claimTime: 1676793601,
              claimTokenAllocation: 166666.66,
            },
            {
              claimRound: 4,
              claimTime: 1679385601,
              claimTokenAllocation: 166666.66,
            },
            {
              claimRound: 5,
              claimTime: 1681977601,
              claimTokenAllocation: 166666.66,
            },
            {
              claimRound: 6,
              claimTime: 1684569601,
              claimTokenAllocation: 166666.66,
            },
            {
              claimRound: 7,
              claimTime: 1687161601,
              claimTokenAllocation: 166666.66,
            },
            {
              claimRound: 8,
              claimTime: 1689753601,
              claimTokenAllocation: 166666.66,
            },
            {
              claimRound: 9,
              claimTime: 1692345601,
              claimTokenAllocation: 166666.66,
            },
            {
              claimRound: 10,
              claimTime: 1694937601,
              claimTokenAllocation: 166666.66,
            },
            {
              claimRound: 11,
              claimTime: 1697529601,
              claimTokenAllocation: 166666.66,
            },
            {
              claimRound: 12,
              claimTime: 1700121601,
              claimTokenAllocation: 166666.74,
            },
          ],
          index: 8,
          isDeployed: true,
          isDeployedErr: false,
          isMandatory: false,
          isSet: true,
          vaultAddress: '0xe48e2c6E64b207cC275c9d1e83FeEA31F0E5E295',
          vaultName: 'Private',
          vaultTokenAllocation: 2000000,
          vaultType: 'C',
        },
        {
          adminAddress: '0x70115ba3b49D60776AaA2976ADffB5CfABf31689',
          claim: [
            {
              claimRound: 1,
              claimTime: 1656057601,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 2,
              claimTime: 1658649601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 3,
              claimTime: 1661241601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 4,
              claimTime: 1663833601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 5,
              claimTime: 1666425601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 6,
              claimTime: 1669017601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 7,
              claimTime: 1671609601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 8,
              claimTime: 1674201601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 9,
              claimTime: 1676793601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 10,
              claimTime: 1679385601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 11,
              claimTime: 1681977601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 12,
              claimTime: 1684569601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 13,
              claimTime: 1687161601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 14,
              claimTime: 1689753601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 15,
              claimTime: 1692345601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 16,
              claimTime: 1694937601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 17,
              claimTime: 1697529601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 18,
              claimTime: 1700121601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 19,
              claimTime: 1702713601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 20,
              claimTime: 1705305601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 21,
              claimTime: 1707897601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 22,
              claimTime: 1710489601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 23,
              claimTime: 1713081601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 24,
              claimTime: 1715673601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 25,
              claimTime: 1718265601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 26,
              claimTime: 1720857601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 27,
              claimTime: 1723449601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 28,
              claimTime: 1726041601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 29,
              claimTime: 1728633601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 30,
              claimTime: 1731225601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 31,
              claimTime: 1733817601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 32,
              claimTime: 1736409601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 33,
              claimTime: 1739001601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 34,
              claimTime: 1741593601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 35,
              claimTime: 1744185601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 36,
              claimTime: 1746777601,
              claimTokenAllocation: 13888.88,
            },
            {
              claimRound: 37,
              claimTime: 1749369601,
              claimTokenAllocation: 13889.2,
            },
          ],
          index: 9,
          isDeployed: true,
          isDeployedErr: false,
          isMandatory: false,
          isSet: true,
          vaultAddress: '0x8079944D2C31d9642E8E71a19082800C6a292147',
          vaultName: 'Partner',
          vaultTokenAllocation: 1000000,
          vaultType: 'C',
        },
        {
          adminAddress: '0x70115ba3b49D60776AaA2976ADffB5CfABf31689',
          claim: [
            {
              claimRound: 1,
              claimTime: 1656057601,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 1,
              claimTime: 1671609601,
              claimTokenAllocation: 400000,
            },
            {
              claimRound: 1,
              claimTime: 1687161601,
              claimTokenAllocation: 300000,
            },
          ],
          index: 10,
          isDeployed: true,
          isDeployedErr: false,
          isMandatory: false,
          isSet: true,
          vaultAddress: '0x3FAc6f923d7B7ebC66781CAFF0Cc469a5449d9A3',
          vaultName: 'Marketing',
          vaultTokenAllocation: 1200000,
          vaultType: 'C',
        },
        {
          adminAddress: '0x70115ba3b49D60776AaA2976ADffB5CfABf31689',
          claim: [
            {
              claimRound: 1,
              claimTime: 1671609601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 2,
              claimTime: 1674201601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 3,
              claimTime: 1676793601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 4,
              claimTime: 1679385601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 5,
              claimTime: 1681977601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 6,
              claimTime: 1684569601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 7,
              claimTime: 1687161601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 8,
              claimTime: 1689753601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 9,
              claimTime: 1692345601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 10,
              claimTime: 1694937601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 11,
              claimTime: 1697529601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 12,
              claimTime: 1700121601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 13,
              claimTime: 1702713601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 14,
              claimTime: 1705305601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 15,
              claimTime: 1707897601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 16,
              claimTime: 1710489601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 17,
              claimTime: 1713081601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 18,
              claimTime: 1715673601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 19,
              claimTime: 1718265601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 20,
              claimTime: 1720857601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 21,
              claimTime: 1723449601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 22,
              claimTime: 1726041601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 23,
              claimTime: 1728633601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 24,
              claimTime: 1731225601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 25,
              claimTime: 1733817601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 26,
              claimTime: 1736409601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 27,
              claimTime: 1739001601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 28,
              claimTime: 1741593601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 29,
              claimTime: 1744185601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 30,
              claimTime: 1746777601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 31,
              claimTime: 1749369601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 32,
              claimTime: 1751961601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 33,
              claimTime: 1754553601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 34,
              claimTime: 1757145601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 35,
              claimTime: 1759737601,
              claimTokenAllocation: 27777.77,
            },
            {
              claimRound: 36,
              claimTime: 1762329601,
              claimTokenAllocation: 27778.05,
            },
          ],
          index: 11,
          isDeployed: true,
          isDeployedErr: false,
          isMandatory: false,
          isSet: true,
          name: 'Team',
          vaultAddress: '0x0ab0799d53DB9361Aa7A6334B86CFb1fC76E5F85',
          vaultName: 'Team',
          vaultTokenAllocation: 1000000,
          vaultType: 'C',
        },
        {
          adminAddress: '0x70115ba3b49D60776AaA2976ADffB5CfABf31689',
          claim: [
            {
              claimRound: 1,
              claimTime: 1656057601,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 2,
              claimTime: 1658649601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 3,
              claimTime: 1661241601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 4,
              claimTime: 1663833601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 5,
              claimTime: 1666425601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 6,
              claimTime: 1669017601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 7,
              claimTime: 1671609601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 8,
              claimTime: 1674201601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 9,
              claimTime: 1676793601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 10,
              claimTime: 1679385601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 11,
              claimTime: 1681977601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 12,
              claimTime: 1684569601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 13,
              claimTime: 1687161601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 14,
              claimTime: 1689753601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 15,
              claimTime: 1692345601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 16,
              claimTime: 1694937601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 17,
              claimTime: 1697529601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 18,
              claimTime: 1700121601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 19,
              claimTime: 1702713601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 20,
              claimTime: 1705305601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 21,
              claimTime: 1707897601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 22,
              claimTime: 1710489601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 23,
              claimTime: 1713081601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 24,
              claimTime: 1715673601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 25,
              claimTime: 1718265601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 26,
              claimTime: 1720857601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 27,
              claimTime: 1723449601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 28,
              claimTime: 1726041601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 29,
              claimTime: 1728633601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 30,
              claimTime: 1731225601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 31,
              claimTime: 1733817601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 32,
              claimTime: 1736409601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 33,
              claimTime: 1739001601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 34,
              claimTime: 1741593601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 35,
              claimTime: 1744185601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 36,
              claimTime: 1746777601,
              claimTokenAllocation: 41666.66,
            },
            {
              claimRound: 37,
              claimTime: 1749369601,
              claimTokenAllocation: 41666.9,
            },
          ],
          index: 12,
          isDeployed: true,
          isDeployedErr: false,
          isMandatory: false,
          isSet: true,
          name: 'Community',
          vaultAddress: '0x5825341F203D7Dbb13B0ee2dDA20C4115cc151Be',
          vaultName: 'Community',
          vaultTokenAllocation: 2000000,
          vaultType: 'C',
        },
      ],
      website: 'https://www.lyda.so/',
    },
    '-NU-RLXQoqAm5Gm_VwPP': {
      description: '',
      isAllDeployed: false,
      isSimplified: true,
      isTokenDeployed: false,
      isTokenDeployedErr: false,
      owner: '0xfA36995FC6B4E9C17E35191A802901741d929960',
      ownerAddress: '0xfA36995FC6B4E9C17E35191A802901741d929960',
      projectTokenPrice: 0,
      salePrice: 0,
      sector: 'Simple',
      tokenAddress: '',
      tokenOwnerAccount: '0xfA36995FC6B4E9C17E35191A802901741d929960',
      tokenSymbolImage: '',
      tokenType: 'A',
      tosPrice: 0,
      totalTokenAllocation: 0,
      vaults: [
        {
          addressForReceiving: '',
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 0,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          publicRound1: 0,
          publicRound1End: 0,
          publicRound2: 0,
          publicRound2End: 0,
          snapshot: 0,
          stosTier: {
            fourTier: {
              requiredStos: 6000,
            },
            oneTier: {
              requiredStos: 600,
            },
            threeTier: {
              requiredStos: 2200,
            },
            twoTier: {
              requiredStos: 1200,
            },
          },
          tokenAllocationForLiquidity: 10,
          vaultName: 'Public',
          vaultTokenAllocation: 0,
          vaultType: 'Public',
          whitelist: 0,
          whitelistEnd: 0,
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 1,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Initial Liquidity',
          vaultTokenAllocation: 0,
          vaultType: 'Initial Liquidity',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
              claimTokenAllocation: 50,
            },
            {
              claimRound: 2,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 3,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 4,
              claimTokenAllocation: 16,
            },
          ],
          index: 2,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Vesting',
          vaultTokenAllocation: 0,
          vaultType: 'Vesting',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 3,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TON Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TON Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 4,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TOS Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TOS Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 5,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
          tokenPair: 'WTON-TOS',
          vaultName: 'WTON-TOS LP Reward',
          vaultTokenAllocation: 0,
          vaultType: 'WTON-TOS LP Reward',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 6,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Liquidity Incentive',
          vaultTokenAllocation: 0,
          vaultType: 'Liquidity Incentive',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 7,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Ecosystem',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 8,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Team',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
      ],
    },
    '-NU63_wXzEuJvIWEyNxW': {
      description: '',
      isAllDeployed: false,
      isSimplified: true,
      isTokenDeployed: false,
      isTokenDeployedErr: false,
      owner: '0x8c595DA827F4182bC0E3917BccA8e654DF8223E1',
      ownerAddress: '0x8c595DA827F4182bC0E3917BccA8e654DF8223E1',
      projectName: 'test',
      projectTokenPrice: 0,
      salePrice: 0,
      sector: 'Simple',
      tokenAddress: '',
      tokenOwnerAccount: '0x8c595DA827F4182bC0E3917BccA8e654DF8223E1',
      tokenSymbolImage: '',
      tokenType: 'A',
      tosPrice: 0,
      totalTokenAllocation: 0,
      vaults: [
        {
          addressForReceiving: '',
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 0,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          publicRound1: 0,
          publicRound1End: 0,
          publicRound2: 0,
          publicRound2End: 0,
          snapshot: 0,
          stosTier: {
            fourTier: {
              requiredStos: 6000,
            },
            oneTier: {
              requiredStos: 600,
            },
            threeTier: {
              requiredStos: 2200,
            },
            twoTier: {
              requiredStos: 1200,
            },
          },
          tokenAllocationForLiquidity: 10,
          vaultName: 'Public',
          vaultTokenAllocation: 0,
          vaultType: 'Public',
          whitelist: 0,
          whitelistEnd: 0,
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 1,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Initial Liquidity',
          vaultTokenAllocation: 0,
          vaultType: 'Initial Liquidity',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
              claimTokenAllocation: 50,
            },
            {
              claimRound: 2,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 3,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 4,
              claimTokenAllocation: 16,
            },
          ],
          index: 2,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Vesting',
          vaultTokenAllocation: 0,
          vaultType: 'Vesting',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 3,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TON Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TON Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 4,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TOS Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TOS Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 5,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
          tokenPair: 'WTON-TOS',
          vaultName: 'WTON-TOS LP Reward',
          vaultTokenAllocation: 0,
          vaultType: 'WTON-TOS LP Reward',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 6,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Liquidity Incentive',
          vaultTokenAllocation: 0,
          vaultType: 'Liquidity Incentive',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 7,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Ecosystem',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 8,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Team',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
      ],
    },
    '-NUPdy1DcoMqwBulV737': {
      description: '',
      isAllDeployed: false,
      isSimplified: true,
      isTokenDeployed: false,
      isTokenDeployedErr: false,
      owner: '0x8c595DA827F4182bC0E3917BccA8e654DF8223E1',
      ownerAddress: '0x8c595DA827F4182bC0E3917BccA8e654DF8223E1',
      projectTokenPrice: 0,
      salePrice: 0,
      sector: 'Simple',
      tokenAddress: '',
      tokenOwnerAccount: '0x8c595DA827F4182bC0E3917BccA8e654DF8223E1',
      tokenSymbolImage: '',
      tokenType: 'A',
      tosPrice: 0,
      totalTokenAllocation: 0,
      vaults: [
        {
          addressForReceiving: '',
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 0,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          publicRound1: 0,
          publicRound1End: 0,
          publicRound2: 0,
          publicRound2End: 0,
          snapshot: 0,
          stosTier: {
            fourTier: {
              requiredStos: 6000,
            },
            oneTier: {
              requiredStos: 600,
            },
            threeTier: {
              requiredStos: 2200,
            },
            twoTier: {
              requiredStos: 1200,
            },
          },
          tokenAllocationForLiquidity: 10,
          vaultName: 'Public',
          vaultTokenAllocation: 0,
          vaultType: 'Public',
          whitelist: 0,
          whitelistEnd: 0,
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 1,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Initial Liquidity',
          vaultTokenAllocation: 0,
          vaultType: 'Initial Liquidity',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
              claimTokenAllocation: 50,
            },
            {
              claimRound: 2,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 3,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 4,
              claimTokenAllocation: 16,
            },
          ],
          index: 2,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Vesting',
          vaultTokenAllocation: 0,
          vaultType: 'Vesting',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 3,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TON Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TON Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 4,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TOS Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TOS Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 5,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
          tokenPair: 'WTON-TOS',
          vaultName: 'WTON-TOS LP Reward',
          vaultTokenAllocation: 0,
          vaultType: 'WTON-TOS LP Reward',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 6,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Liquidity Incentive',
          vaultTokenAllocation: 0,
          vaultType: 'Liquidity Incentive',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 7,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Ecosystem',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 8,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Team',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
      ],
    },
    '-NadUHfSlhWt5cS1-zm6': {
      description: '<p>Mars is the dream of the humanity.</p>',
      isAllDeployed: false,
      isSimplified: true,
      isTokenDeployed: false,
      isTokenDeployedErr: false,
      owner: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      ownerAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      projectName: 'Mars Project',
      projectTokenPrice: 0,
      salePrice: 0,
      sector: 'Simple',
      tokenAddress: '',
      tokenName: 'Mars',
      tokenOwnerAccount: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      tokenSymbol: 'MARS',
      tokenSymbolImage: '',
      tokenType: 'A',
      tosPrice: 0,
      totalTokenAllocation: 0,
      vaults: [
        {
          addressForReceiving: '',
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 0,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          publicRound1: 1691800832,
          publicRound1End: 1691973632,
          publicRound2: 1692060032,
          publicRound2End: 1692492032,
          snapshot: 1691541630,
          stosTier: {
            fourTier: {
              requiredStos: 6000,
            },
            oneTier: {
              requiredStos: 600,
            },
            threeTier: {
              requiredStos: 2200,
            },
            twoTier: {
              requiredStos: 1200,
            },
          },
          tokenAllocationForLiquidity: 10,
          vaultName: 'Public',
          vaultTokenAllocation: 0,
          vaultType: 'Public',
          whitelist: 1691541631,
          whitelistEnd: 1691714431,
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 1,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Initial Liquidity',
          vaultTokenAllocation: 0,
          vaultType: 'Initial Liquidity',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
              claimTokenAllocation: 50,
            },
            {
              claimRound: 2,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 3,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 4,
              claimTokenAllocation: 16,
            },
          ],
          index: 2,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Vesting',
          vaultTokenAllocation: 0,
          vaultType: 'Vesting',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 3,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TON Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TON Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 4,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TOS Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TOS Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 5,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
          tokenPair: 'WTON-TOS',
          vaultName: 'WTON-TOS LP Reward',
          vaultTokenAllocation: 0,
          vaultType: 'WTON-TOS LP Reward',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 6,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Liquidity Incentive',
          vaultTokenAllocation: 0,
          vaultType: 'Liquidity Incentive',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 7,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Ecosystem',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 8,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Team',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
      ],
    },
    '-Naf2hl_ZCb4DgWuKZ_W': {
      description: '<p>MARS is the dream of the humanity</p>',
      discord: '',
      fundingTarget: 1000000,
      isAllDeployed: false,
      isSimplified: false,
      isTokenDeployed: false,
      isTokenDeployedErr: false,
      marketCap: 3333333.3333333335,
      medium: '',
      owner: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      ownerAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      projectName: 'Mars Project',
      projectTokenPrice: 4.84,
      salePrice: 4.84,
      sector: 'Simple',
      stablePrice: 0.333333,
      telegram: '',
      tokenAddress: '',
      tokenName: 'MARS',
      tokenOwnerAccount: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      tokenSymbol: 'MARS',
      tokenSymbolImage: '',
      tokenType: 'A',
      tosPrice: 4.92,
      totalSupply: 10000000,
      totalTokenAllocation: 10000000,
      twitter: '',
      vaults: [
        {
          addressForReceiving: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692492033,
              claimTokenAllocation: 750000,
            },
            {
              claimRound: 2,
              claimTime: 1700268033,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 3,
              claimTime: 1708044033,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 4,
              claimTime: 1715820033,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 5,
              claimTime: 1723596033,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 6,
              claimTime: 1731372033,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 6,
              claimTime: 1739148033,
              claimTokenAllocation: 375000,
            },
          ],
          claimStart: 1692492033,
          hardCap: 309674.22,
          index: 0,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          publicRound1: 1691800832,
          publicRound1Allocation: 1500000,
          publicRound1End: 1691973632,
          publicRound2: 1692060032,
          publicRound2Allocation: 1500000,
          publicRound2End: 1692492032,
          snapshot: 1691541630,
          stosTier: {
            fourTier: {
              allocatedToken: 900000,
              requiredStos: 6000,
            },
            oneTier: {
              allocatedToken: 90000,
              requiredStos: 600,
            },
            threeTier: {
              allocatedToken: 330000,
              requiredStos: 2200,
            },
            twoTier: {
              allocatedToken: 180000,
              requiredStos: 1200,
            },
          },
          tokenAllocationForLiquidity: 10,
          vaultName: 'Public',
          vaultTokenAllocation: 3000000,
          vaultType: 'Public',
          whitelist: 1691541631,
          whitelistEnd: 1691714431,
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692492033,
              claimTokenAllocation: 300000,
            },
          ],
          index: 1,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          startTime: 1692492033,
          tokenPair: 'MARS-TOS',
          vaultName: 'Initial Liquidity',
          vaultTokenAllocation: 300000,
          vaultType: 'Initial Liquidity',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692492033,
              claimTokenAllocation: 40,
            },
            {
              claimRound: 2,
              claimTime: 1723596033,
              claimTokenAllocation: 20,
            },
            {
              claimRound: 3,
              claimTime: 1754700033,
              claimTokenAllocation: 20,
            },
            {
              claimRound: 4,
              claimTime: 1785804033,
              claimTokenAllocation: 20,
            },
          ],
          index: 2,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Vesting',
          vaultTokenAllocation: 0,
          vaultType: 'Vesting',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692492033,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 2,
              claimTime: 1708044033,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 3,
              claimTime: 1723596033,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 4,
              claimTime: 1739148033,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 5,
              claimTime: 1754700033,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 6,
              claimTime: 1770252033,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 7,
              claimTime: 1785804033,
              claimTokenAllocation: 17858,
            },
          ],
          index: 3,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TON Staker',
          vaultTokenAllocation: 125000,
          vaultType: 'TON Staker',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692492033,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 2,
              claimTime: 1708044033,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 3,
              claimTime: 1723596033,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 4,
              claimTime: 1739148033,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 5,
              claimTime: 1754700033,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 6,
              claimTime: 1770252033,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 7,
              claimTime: 1785804033,
              claimTokenAllocation: 17858,
            },
          ],
          index: 4,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TOS Staker',
          vaultTokenAllocation: 125000,
          vaultType: 'TOS Staker',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692492033,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 2,
              claimTime: 1695084033,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 3,
              claimTime: 1697676033,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 4,
              claimTime: 1700268033,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 5,
              claimTime: 1702860033,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 6,
              claimTime: 1705452033,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 6,
              claimTime: 1785804033,
              claimTokenAllocation: 35716,
            },
          ],
          index: 5,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
          tokenPair: 'WTON-TOS',
          vaultName: 'WTON-TOS LP Reward',
          vaultTokenAllocation: 250000,
          vaultType: 'WTON-TOS LP Reward',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692492033,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 2,
              claimTime: 1700268033,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 3,
              claimTime: 1708044033,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 4,
              claimTime: 1715820033,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 5,
              claimTime: 1723596033,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 6,
              claimTime: 1731372033,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 6,
              claimTime: 1739148033,
              claimTokenAllocation: 171426,
            },
          ],
          index: 6,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          tokenPair: 'MARS-TOS',
          vaultName: 'Liquidity Incentive',
          vaultTokenAllocation: 1200000,
          vaultType: 'Liquidity Incentive',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692492033,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 2,
              claimTime: 1708044033,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 3,
              claimTime: 1723596033,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 4,
              claimTime: 1739148033,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 5,
              claimTime: 1754700033,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 6,
              claimTime: 1770252033,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 6,
              claimTime: 1785804033,
              claimTokenAllocation: 500000,
            },
          ],
          index: 7,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Ecosystem',
          vaultTokenAllocation: 3500000,
          vaultType: 'C',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1726188033,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 2,
              claimTime: 1741740033,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 3,
              claimTime: 1757292033,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 4,
              claimTime: 1772844033,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 5,
              claimTime: 1788396033,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 6,
              claimTime: 1803948033,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 6,
              claimTime: 1816908033,
              claimTokenAllocation: 214284,
            },
          ],
          index: 8,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Team',
          vaultTokenAllocation: 1500000,
          vaultType: 'C',
        },
      ],
      website: '',
    },
    '-NanpXCsobE17hp8TKHG': {
      description: '<p>test</p>',
      discord: '',
      fundingTarget: 1000000,
      isAllDeployed: false,
      isSimplified: false,
      isTokenDeployed: false,
      isTokenDeployedErr: false,
      marketCap: 3333333.3333333335,
      medium: '',
      owner: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      ownerAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      projectName: 'test',
      projectTokenPrice: 4.68,
      salePrice: 4.68,
      sector: 'Simple',
      stablePrice: 0.333333,
      telegram: '',
      tokenAddress: '',
      tokenName: 'test',
      tokenOwnerAccount: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      tokenSymbol: 'test',
      tokenSymbolImage: '',
      tokenType: 'A',
      tosPrice: 4.76,
      totalSupply: 10000000,
      totalTokenAllocation: '1500000350000012000002500001250003425000',
      twitter: '',
      vaults: [
        {
          addressForReceiving: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692666032,
              claimTokenAllocation: 750000,
            },
            {
              claimRound: 2,
              claimTime: 1700442032,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 3,
              claimTime: 1708218032,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 4,
              claimTime: 1715994032,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 5,
              claimTime: 1723770032,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 6,
              claimTime: 1731546032,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 6,
              claimTime: 1739322032,
              claimTokenAllocation: 375000,
            },
          ],
          claimStart: 1692666032,
          hardCap: 320512.82,
          index: 0,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          publicRound1: 1691974831,
          publicRound1Allocation: 1500000,
          publicRound1End: 1692147631,
          publicRound2: 1692234031,
          publicRound2Allocation: 1500000,
          publicRound2End: 1692666031,
          snapshot: 1691715629,
          stosTier: {
            fourTier: {
              allocatedToken: 900000,
              requiredStos: 6000,
            },
            oneTier: {
              allocatedToken: 90000,
              requiredStos: 600,
            },
            threeTier: {
              allocatedToken: 330000,
              requiredStos: 2200,
            },
            twoTier: {
              allocatedToken: 180000,
              requiredStos: 1200,
            },
          },
          tokenAllocationForLiquidity: 10,
          vaultName: 'Public',
          vaultTokenAllocation: 3000000,
          vaultType: 'Public',
          whitelist: 1691715630,
          whitelistEnd: 1691888430,
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692666032,
              claimTokenAllocation: 300000,
            },
          ],
          index: 1,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          startTime: 1692666032,
          tokenPair: 'test-TOS',
          vaultName: 'Initial Liquidity',
          vaultTokenAllocation: 300000,
          vaultType: 'Initial Liquidity',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692666032,
              claimTokenAllocation: 40,
            },
            {
              claimRound: 2,
              claimTime: 1723770032,
              claimTokenAllocation: 20,
            },
            {
              claimRound: 3,
              claimTime: 1754874032,
              claimTokenAllocation: 20,
            },
            {
              claimRound: 4,
              claimTime: 1785978032,
              claimTokenAllocation: 20,
            },
          ],
          index: 2,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Vesting',
          vaultTokenAllocation: 0,
          vaultType: 'Vesting',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692666032,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 2,
              claimTime: 1708218032,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 3,
              claimTime: 1723770032,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 4,
              claimTime: 1739322032,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 5,
              claimTime: 1754874032,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 6,
              claimTime: 1770426032,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 7,
              claimTime: 1785978032,
              claimTokenAllocation: 17858,
            },
          ],
          index: 3,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TON Staker',
          vaultTokenAllocation: 125000,
          vaultType: 'TON Staker',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692666032,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 2,
              claimTime: 1708218032,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 3,
              claimTime: 1723770032,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 4,
              claimTime: 1739322032,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 5,
              claimTime: 1754874032,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 6,
              claimTime: 1770426032,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 7,
              claimTime: 1785978032,
              claimTokenAllocation: 17858,
            },
          ],
          index: 4,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          name: 'TOS Staker',
          vaultName: 'TOS Staker',
          vaultTokenAllocation: '125000',
          vaultType: 'TOS Staker',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692666032,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 2,
              claimTime: 1695258032,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 3,
              claimTime: 1697850032,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 4,
              claimTime: 1700442032,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 5,
              claimTime: 1703034032,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 6,
              claimTime: 1705626032,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 6,
              claimTime: 1785978032,
              claimTokenAllocation: 35716,
            },
          ],
          index: 5,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
          tokenPair: 'WTON-TOS',
          vaultName: 'WTON-TOS LP Reward',
          vaultTokenAllocation: 250000,
          vaultType: 'WTON-TOS LP Reward',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692666032,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 2,
              claimTime: 1700442032,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 3,
              claimTime: 1708218032,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 4,
              claimTime: 1715994032,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 5,
              claimTime: 1723770032,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 6,
              claimTime: 1731546032,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 6,
              claimTime: 1739322032,
              claimTokenAllocation: 171426,
            },
          ],
          index: 6,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          tokenPair: 'test-TOS',
          vaultName: 'Liquidity Incentive',
          vaultTokenAllocation: 1200000,
          vaultType: 'Liquidity Incentive',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692666032,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 2,
              claimTime: 1708218032,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 3,
              claimTime: 1723770032,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 4,
              claimTime: 1739322032,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 5,
              claimTime: 1754874032,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 6,
              claimTime: 1770426032,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 6,
              claimTime: 1785978032,
              claimTokenAllocation: 500000,
            },
          ],
          index: 7,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Ecosystem',
          vaultTokenAllocation: 3500000,
          vaultType: 'C',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1726362032,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 2,
              claimTime: 1741914032,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 3,
              claimTime: 1757466032,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 4,
              claimTime: 1773018032,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 5,
              claimTime: 1788570032,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 6,
              claimTime: 1804122032,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 6,
              claimTime: 1817082032,
              claimTokenAllocation: 214284,
            },
          ],
          index: 8,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Team',
          vaultTokenAllocation: 1500000,
          vaultType: 'C',
        },
      ],
      website: '',
    },
    '-Nao6k8GCC_uTjbrlxby': {
      description: '<p>test</p>',
      isAllDeployed: false,
      isSimplified: true,
      isTokenDeployed: false,
      isTokenDeployedErr: false,
      owner: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      ownerAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      projectName: 'test',
      projectTokenPrice: 0,
      salePrice: 0,
      sector: 'Simple',
      tokenAddress: '',
      tokenName: 'test',
      tokenOwnerAccount: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      tokenSymbol: 'test',
      tokenSymbolImage: '',
      tokenType: 'A',
      tosPrice: 0,
      totalTokenAllocation: 0,
      vaults: [
        {
          addressForReceiving: '',
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 0,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          publicRound1: 1691974831,
          publicRound1End: 1692147631,
          publicRound2: 1692234031,
          publicRound2End: 1692666031,
          snapshot: 1691715629,
          stosTier: {
            fourTier: {
              requiredStos: 6000,
            },
            oneTier: {
              requiredStos: 600,
            },
            threeTier: {
              requiredStos: 2200,
            },
            twoTier: {
              requiredStos: 1200,
            },
          },
          tokenAllocationForLiquidity: 10,
          vaultName: 'Public',
          vaultTokenAllocation: 0,
          vaultType: 'Public',
          whitelist: 1691715630,
          whitelistEnd: 1691888430,
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 1,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Initial Liquidity',
          vaultTokenAllocation: 0,
          vaultType: 'Initial Liquidity',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
              claimTokenAllocation: 50,
            },
            {
              claimRound: 2,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 3,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 4,
              claimTokenAllocation: 16,
            },
          ],
          index: 2,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Vesting',
          vaultTokenAllocation: 0,
          vaultType: 'Vesting',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 3,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TON Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TON Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 4,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TOS Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TOS Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 5,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
          tokenPair: 'WTON-TOS',
          vaultName: 'WTON-TOS LP Reward',
          vaultTokenAllocation: 0,
          vaultType: 'WTON-TOS LP Reward',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 6,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Liquidity Incentive',
          vaultTokenAllocation: 0,
          vaultType: 'Liquidity Incentive',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 7,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Ecosystem',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 8,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Team',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
      ],
    },
    '-Naysr_IDEUHUe3l1DWe': {
      description: '<p>test</p>',
      fundingTarget: 1000000,
      isAllDeployed: false,
      isSimplified: true,
      isTokenDeployed: false,
      isTokenDeployedErr: false,
      marketCap: 3333333.3333333335,
      owner: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      ownerAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      projectName: 'test',
      projectTokenPrice: 4.49,
      salePrice: 4.49,
      sector: 'Simple',
      stablePrice: 0.333333,
      tokenAddress: '',
      tokenName: 'test',
      tokenOwnerAccount: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      tokenSymbol: 'test',
      tokenSymbolImage: '',
      tokenType: 'A',
      tosPrice: 1,
      totalSupply: 10000000,
      totalTokenAllocation: 10000000,
      vaults: [
        {
          addressForReceiving: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692852047,
              claimTokenAllocation: 750000,
            },
            {
              claimRound: 2,
              claimTime: 1700628047,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 3,
              claimTime: 1708404047,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 4,
              claimTime: 1716180047,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 5,
              claimTime: 1723956047,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 6,
              claimTime: 1731732047,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 6,
              claimTime: 1739508047,
              claimTokenAllocation: 375000,
            },
          ],
          claimStart: 1692852047,
          hardCap: 333856.37,
          index: 0,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          publicRound1: 1692160846,
          publicRound1Allocation: 1500000,
          publicRound1End: 1692333646,
          publicRound2: 1692420046,
          publicRound2Allocation: 1500000,
          publicRound2End: 1692852046,
          snapshot: 1691901644,
          stosTier: {
            fourTier: {
              allocatedToken: 900000,
              requiredStos: 6000,
            },
            oneTier: {
              allocatedToken: 90000,
              requiredStos: 600,
            },
            threeTier: {
              allocatedToken: 330000,
              requiredStos: 2200,
            },
            twoTier: {
              allocatedToken: 180000,
              requiredStos: 1200,
            },
          },
          tokenAllocationForLiquidity: 10,
          vaultName: 'Public',
          vaultTokenAllocation: 3000000,
          vaultType: 'Public',
          whitelist: 1691901645,
          whitelistEnd: 1692074445,
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692852047,
              claimTokenAllocation: 300000,
            },
          ],
          index: 1,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          startTime: 1692852047,
          tokenPair: 'test-TOS',
          vaultName: 'Initial Liquidity',
          vaultTokenAllocation: 300000,
          vaultType: 'Initial Liquidity',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692852047,
              claimTokenAllocation: 40,
            },
            {
              claimRound: 2,
              claimTime: 1723956047,
              claimTokenAllocation: 20,
            },
            {
              claimRound: 3,
              claimTime: 1755060047,
              claimTokenAllocation: 20,
            },
            {
              claimRound: 4,
              claimTime: 1786164047,
              claimTokenAllocation: 20,
            },
          ],
          index: 2,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Vesting',
          vaultTokenAllocation: 0,
          vaultType: 'Vesting',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692852047,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 2,
              claimTime: 1708404047,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 3,
              claimTime: 1723956047,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 4,
              claimTime: 1739508047,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 5,
              claimTime: 1755060047,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 6,
              claimTime: 1770612047,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 7,
              claimTime: 1786164047,
              claimTokenAllocation: 17858,
            },
          ],
          index: 3,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TON Staker',
          vaultTokenAllocation: 125000,
          vaultType: 'TON Staker',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692852047,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 2,
              claimTime: 1708404047,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 3,
              claimTime: 1723956047,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 4,
              claimTime: 1739508047,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 5,
              claimTime: 1755060047,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 6,
              claimTime: 1770612047,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 7,
              claimTime: 1786164047,
              claimTokenAllocation: 17858,
            },
          ],
          index: 4,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TOS Staker',
          vaultTokenAllocation: 125000,
          vaultType: 'TOS Staker',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692852047,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 2,
              claimTime: 1695444047,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 3,
              claimTime: 1698036047,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 4,
              claimTime: 1700628047,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 5,
              claimTime: 1703220047,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 6,
              claimTime: 1705812047,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 6,
              claimTime: 1786164047,
              claimTokenAllocation: 35716,
            },
          ],
          index: 5,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
          tokenPair: 'WTON-TOS',
          vaultName: 'WTON-TOS LP Reward',
          vaultTokenAllocation: 250000,
          vaultType: 'WTON-TOS LP Reward',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692852047,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 2,
              claimTime: 1700628047,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 3,
              claimTime: 1708404047,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 4,
              claimTime: 1716180047,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 5,
              claimTime: 1723956047,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 6,
              claimTime: 1731732047,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 6,
              claimTime: 1739508047,
              claimTokenAllocation: 171426,
            },
          ],
          index: 6,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          tokenPair: 'test-TOS',
          vaultName: 'Liquidity Incentive',
          vaultTokenAllocation: 1200000,
          vaultType: 'Liquidity Incentive',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1692852047,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 2,
              claimTime: 1708404047,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 3,
              claimTime: 1723956047,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 4,
              claimTime: 1739508047,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 5,
              claimTime: 1755060047,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 6,
              claimTime: 1770612047,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 6,
              claimTime: 1786164047,
              claimTokenAllocation: 500000,
            },
          ],
          index: 7,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Ecosystem',
          vaultTokenAllocation: 3500000,
          vaultType: 'C',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1726548047,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 2,
              claimTime: 1742100047,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 3,
              claimTime: 1757652047,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 4,
              claimTime: 1773204047,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 5,
              claimTime: 1788756047,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 6,
              claimTime: 1804308047,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 6,
              claimTime: 1817268047,
              claimTokenAllocation: 214284,
            },
          ],
          index: 8,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Team',
          vaultTokenAllocation: 1500000,
          vaultType: 'C',
        },
      ],
    },
    '-NftQckyPmItQCFqGirr': {
      description: '<p>test</p>',
      isAllDeployed: false,
      isSimplified: true,
      isTokenDeployed: false,
      isTokenDeployedErr: false,
      owner: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      ownerAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      projectName: 'test',
      projectTokenPrice: 0,
      salePrice: 0,
      sector: 'Simple',
      tokenAddress: '',
      tokenName: 'test',
      tokenOwnerAccount: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      tokenSymbol: 'test',
      tokenSymbolImage: '',
      tokenType: 'A',
      tosPrice: 0,
      totalTokenAllocation: 0,
      vaults: [
        {
          addressForReceiving: '',
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 0,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          publicRound1: 1697433471,
          publicRound1End: 1697606271,
          publicRound2: 1698124671,
          publicRound2End: 1698556671,
          snapshot: 1697174269,
          stosTier: {
            fourTier: {
              requiredStos: 6000,
            },
            oneTier: {
              requiredStos: 600,
            },
            threeTier: {
              requiredStos: 2200,
            },
            twoTier: {
              requiredStos: 1200,
            },
          },
          tokenAllocationForLiquidity: 10,
          vaultName: 'Public',
          vaultTokenAllocation: 0,
          vaultType: 'Public',
          whitelist: 1697174270,
          whitelistEnd: 1697347070,
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 1,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Initial Liquidity',
          vaultTokenAllocation: 0,
          vaultType: 'Initial Liquidity',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
              claimTokenAllocation: 50,
            },
            {
              claimRound: 2,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 3,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 4,
              claimTokenAllocation: 16,
            },
          ],
          index: 2,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Vesting',
          vaultTokenAllocation: 0,
          vaultType: 'Vesting',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 3,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TON Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TON Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 4,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TOS Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TOS Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 5,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
          tokenPair: 'WTON-TOS',
          vaultName: 'WTON-TOS LP Reward',
          vaultTokenAllocation: 0,
          vaultType: 'WTON-TOS LP Reward',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 6,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Liquidity Incentive',
          vaultTokenAllocation: 0,
          vaultType: 'Liquidity Incentive',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 7,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Ecosystem',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 8,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Team',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
      ],
    },
    '-NftSUZGmeTlXnHwaQ9V': {
      description: '<p>test</p>',
      fundingTarget: 1000000,
      isAllDeployed: false,
      isSimplified: true,
      isTokenDeployed: false,
      isTokenDeployedErr: false,
      marketCap: 3333333.3333333335,
      owner: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      ownerAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      projectName: 'test',
      projectTokenPrice: 3.99,
      salePrice: 3.99,
      sector: 'Simple',
      stablePrice: 0.333333,
      tokenAddress: '',
      tokenName: 'test',
      tokenOwnerAccount: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      tokenSymbol: 'test',
      tokenSymbolImage: '',
      tokenType: 'A',
      tosPrice: 3.36,
      totalSupply: 10000000,
      totalTokenAllocation: 10000000,
      vaults: [
        {
          addressForReceiving: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1698130343,
              claimTokenAllocation: 750000,
            },
            {
              claimRound: 2,
              claimTime: 1705906343,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 3,
              claimTime: 1713682343,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 4,
              claimTime: 1721458343,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 5,
              claimTime: 1729234343,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 6,
              claimTime: 1737010343,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 6,
              claimTime: 1744786343,
              claimTokenAllocation: 375000,
            },
          ],
          claimStart: 1698130343,
          hardCap: 375304.93,
          index: 0,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          publicRound1: 1697439142,
          publicRound1Allocation: 1500000,
          publicRound1End: 1697611942,
          publicRound2: 1697698342,
          publicRound2Allocation: 1500000,
          publicRound2End: 1698130342,
          snapshot: 1697179940,
          stosTier: {
            fourTier: {
              allocatedToken: 900000,
              requiredStos: 6000,
            },
            oneTier: {
              allocatedToken: 90000,
              requiredStos: 600,
            },
            threeTier: {
              allocatedToken: 330000,
              requiredStos: 2200,
            },
            twoTier: {
              allocatedToken: 180000,
              requiredStos: 1200,
            },
          },
          tokenAllocationForLiquidity: 10,
          vaultName: 'Public',
          vaultTokenAllocation: 3000000,
          vaultType: 'Public',
          whitelist: 1697179941,
          whitelistEnd: 1697352741,
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1698130343,
              claimTokenAllocation: 300000,
            },
          ],
          index: 1,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          startTime: 1698130343,
          tokenPair: 'test-TOS',
          vaultName: 'Initial Liquidity',
          vaultTokenAllocation: 300000,
          vaultType: 'Initial Liquidity',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1698130343,
              claimTokenAllocation: 40,
            },
            {
              claimRound: 2,
              claimTime: 1729234343,
              claimTokenAllocation: 20,
            },
            {
              claimRound: 3,
              claimTime: 1760338343,
              claimTokenAllocation: 20,
            },
            {
              claimRound: 4,
              claimTime: 1791442343,
              claimTokenAllocation: 20,
            },
          ],
          index: 2,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Vesting',
          vaultTokenAllocation: 0,
          vaultType: 'Vesting',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1698130343,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 2,
              claimTime: 1713682343,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 3,
              claimTime: 1729234343,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 4,
              claimTime: 1744786343,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 5,
              claimTime: 1760338343,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 6,
              claimTime: 1775890343,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 7,
              claimTime: 1791442343,
              claimTokenAllocation: 17858,
            },
          ],
          index: 3,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TON Staker',
          vaultTokenAllocation: 125000,
          vaultType: 'TON Staker',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1698130343,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 2,
              claimTime: 1713682343,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 3,
              claimTime: 1729234343,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 4,
              claimTime: 1744786343,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 5,
              claimTime: 1760338343,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 6,
              claimTime: 1775890343,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 7,
              claimTime: 1791442343,
              claimTokenAllocation: 17858,
            },
          ],
          index: 4,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TOS Staker',
          vaultTokenAllocation: 125000,
          vaultType: 'TOS Staker',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1698130343,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 2,
              claimTime: 1700722343,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 3,
              claimTime: 1703314343,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 4,
              claimTime: 1705906343,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 5,
              claimTime: 1708498343,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 6,
              claimTime: 1711090343,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 6,
              claimTime: 1791442343,
              claimTokenAllocation: 35716,
            },
          ],
          index: 5,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
          tokenPair: 'WTON-TOS',
          vaultName: 'WTON-TOS LP Reward',
          vaultTokenAllocation: 250000,
          vaultType: 'WTON-TOS LP Reward',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1698130343,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 2,
              claimTime: 1705906343,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 3,
              claimTime: 1713682343,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 4,
              claimTime: 1721458343,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 5,
              claimTime: 1729234343,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 6,
              claimTime: 1737010343,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 6,
              claimTime: 1744786343,
              claimTokenAllocation: 171426,
            },
          ],
          index: 6,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          tokenPair: 'test-TOS',
          vaultName: 'Liquidity Incentive',
          vaultTokenAllocation: 1200000,
          vaultType: 'Liquidity Incentive',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1698130343,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 2,
              claimTime: 1713682343,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 3,
              claimTime: 1729234343,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 4,
              claimTime: 1744786343,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 5,
              claimTime: 1760338343,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 6,
              claimTime: 1775890343,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 6,
              claimTime: 1791442343,
              claimTokenAllocation: 500000,
            },
          ],
          index: 7,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Ecosystem',
          vaultTokenAllocation: 3500000,
          vaultType: 'C',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1731826343,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 2,
              claimTime: 1747378343,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 3,
              claimTime: 1762930343,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 4,
              claimTime: 1778482343,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 5,
              claimTime: 1794034343,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 6,
              claimTime: 1809586343,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 6,
              claimTime: 1822546343,
              claimTokenAllocation: 214284,
            },
          ],
          index: 8,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Team',
          vaultTokenAllocation: 1500000,
          vaultType: 'C',
        },
      ],
    },
    '-NhfAjIfIEO1gYIirc7h': {
      description: '<p>Hey there!!!</p>',
      discord: '',
      isAllDeployed: false,
      isSimplified: false,
      isTokenDeployed: false,
      isTokenDeployedErr: false,
      medium: '',
      owner: '0xd8bC680A7F38AeCFDfB0F97D210edA38bdbA54AE',
      ownerAddress: '0xd8bC680A7F38AeCFDfB0F97D210edA38bdbA54AE',
      projectName: 'TEST',
      projectTokenPrice: '100',
      salePrice: 0,
      sector: 'P2E',
      telegram: '',
      tokenAddress: '',
      tokenName: 'TEST',
      tokenOwnerAccount: '0xd8bC680A7F38AeCFDfB0F97D210edA38bdbA54AE',
      tokenSymbol: 'DLZ',
      tokenSymbolImage: '',
      tokenType: 'A',
      tosPrice: 0,
      totalSupply: '10000',
      totalTokenAllocation: '2000200010001000100010000100010000',
      twitter: '',
      vaults: [
        {
          addressForReceiving: '0xC78F3BC6a1f43E6Dd892631A632ca650f7393b71',
          adminAddress: '0xd8bC680A7F38AeCFDfB0F97D210edA38bdbA54AE',
          claim: [
            {
              claimRound: 1,
              claimTime: 1699613996,
              claimTokenAllocation: 1000,
            },
          ],
          hardCap: '100',
          index: 0,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          name: 'Public',
          publicRound1: 1699088336,
          publicRound1Allocation: '500',
          publicRound1End: 1699091996,
          publicRound2: 1699178396,
          publicRound2Allocation: '500',
          publicRound2End: 1699181996,
          snapshot: 1699087854,
          stosTier: {
            fourTier: {
              allocatedToken: '200',
              requiredStos: 6000,
            },
            oneTier: {
              allocatedToken: '100',
              requiredStos: '600',
            },
            threeTier: {
              allocatedToken: '100',
              requiredStos: 2200,
            },
            twoTier: {
              allocatedToken: '100',
              requiredStos: 1200,
            },
          },
          tokenAllocationForLiquidity: 10,
          tokenPair: '',
          vaultName: 'Public',
          vaultTokenAllocation: '1000',
          vaultType: 'Public',
          whitelist: 1699088035,
          whitelistEnd: 1699088335,
        },
        {
          adminAddress: '0xd8bC680A7F38AeCFDfB0F97D210edA38bdbA54AE',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 1,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          name: 'Initial Liquidity',
          vaultName: 'Initial Liquidity',
          vaultTokenAllocation: 1000,
          vaultType: 'Initial Liquidity',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
              claimTime: 1700053196,
              claimTokenAllocation: 50,
            },
            {
              claimRound: 2,
              claimTime: 1700124853,
              claimTokenAllocation: 10,
            },
            {
              claimRound: 3,
              claimTime: 1700179200,
              claimTokenAllocation: 20,
            },
            {
              claimRound: 4,
              claimTime: 1700265600,
              claimTokenAllocation: 20,
            },
          ],
          index: 2,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Vesting',
          vaultTokenAllocation: 0,
          vaultType: 'Vesting',
        },
        {
          adminAddress: '0xd8bC680A7F38AeCFDfB0F97D210edA38bdbA54AE',
          claim: [
            {
              claimRound: 1,
              claimTime: 1699613996,
              claimTokenAllocation: 1000,
            },
          ],
          index: 3,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          name: 'TON Staker',
          vaultName: 'TON Staker',
          vaultTokenAllocation: 1000,
          vaultType: 'TON Staker',
        },
        {
          adminAddress: '0xd8bC680A7F38AeCFDfB0F97D210edA38bdbA54AE',
          claim: [
            {
              claimRound: 1,
              claimTime: 1699613996,
              claimTokenAllocation: 1000,
            },
          ],
          index: 4,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          name: 'TOS Staker',
          vaultName: 'TOS Staker',
          vaultTokenAllocation: 1000,
          vaultType: 'TOS Staker',
        },
        {
          adminAddress: '0xd8bC680A7F38AeCFDfB0F97D210edA38bdbA54AE',
          claim: [
            {
              claimRound: 1,
              claimTime: 1699613996,
              claimTokenAllocation: 1000,
            },
          ],
          index: 5,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          name: 'WTON-TOS LP Reward',
          poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
          tokenPair: 'WTON-TOS',
          vaultName: 'WTON-TOS LP Reward',
          vaultTokenAllocation: 1000,
          vaultType: 'WTON-TOS LP Reward',
        },
        {
          adminAddress: '0xd8bC680A7F38AeCFDfB0F97D210edA38bdbA54AE',
          claim: [
            {
              claimRound: 1,
              claimTime: 1700132396,
              claimTokenAllocation: 1000,
            },
          ],
          index: 6,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          name: 'TEST-TOS LP Reward',
          vaultName: 'Liquidity Incentive',
          vaultTokenAllocation: 1000,
          vaultType: 'Liquidity Incentive',
        },
        {
          adminAddress: '0xd8bC680A7F38AeCFDfB0F97D210edA38bdbA54AE',
          claim: [
            {
              claimRound: 1,
              claimTime: 1699613996,
              claimTokenAllocation: 1000,
            },
          ],
          index: 7,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          name: 'Ecosystem',
          vaultName: 'Ecosystem',
          vaultTokenAllocation: 2000,
          vaultType: 'C',
        },
        {
          adminAddress: '0xd8bC680A7F38AeCFDfB0F97D210edA38bdbA54AE',
          claim: [
            {
              claimRound: 1,
              claimTime: 1699527596,
              claimTokenAllocation: 1000,
            },
          ],
          index: 8,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          name: 'Team',
          vaultName: 'Team',
          vaultTokenAllocation: '2000',
          vaultType: 'C',
        },
      ],
      website: '',
    },
    '-NhjWdtSn9lrafG3ixeO': {
      description: '',
      discord: '',
      isAllDeployed: false,
      isSimplified: false,
      isTokenDeployed: false,
      isTokenDeployedErr: false,
      medium: '',
      owner: '0x8d58995C2EB561Ca21c9bD7935015d739a75c5C0',
      ownerAddress: '0x8d58995C2EB561Ca21c9bD7935015d739a75c5C0',
      projectName: 'myProject',
      projectTokenPrice: 0,
      salePrice: 0,
      sector: 'P2E',
      telegram: '',
      tokenAddress: '',
      tokenName: 'TEST',
      tokenOwnerAccount: '0x8d58995C2EB561Ca21c9bD7935015d739a75c5C0',
      tokenSymbol: 'DLZ',
      tokenSymbolImage: '',
      tokenType: 'A',
      tosPrice: 0,
      totalSupply: '10000',
      totalTokenAllocation: 0,
      twitter: '',
      vaults: [
        {
          addressForReceiving: '',
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 0,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          publicRound1: 0,
          publicRound1End: 0,
          publicRound2: 0,
          publicRound2End: 0,
          snapshot: 0,
          stosTier: {
            fourTier: {
              requiredStos: 6000,
            },
            oneTier: {
              requiredStos: 600,
            },
            threeTier: {
              requiredStos: 2200,
            },
            twoTier: {
              requiredStos: 1200,
            },
          },
          tokenAllocationForLiquidity: 10,
          vaultName: 'Public',
          vaultTokenAllocation: 0,
          vaultType: 'Public',
          whitelist: 0,
          whitelistEnd: 0,
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 1,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Initial Liquidity',
          vaultTokenAllocation: 0,
          vaultType: 'Initial Liquidity',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
              claimTokenAllocation: 50,
            },
            {
              claimRound: 2,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 3,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 4,
              claimTokenAllocation: 16,
            },
          ],
          index: 2,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Vesting',
          vaultTokenAllocation: 0,
          vaultType: 'Vesting',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 3,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TON Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TON Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 4,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TOS Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TOS Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 5,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
          tokenPair: 'WTON-TOS',
          vaultName: 'WTON-TOS LP Reward',
          vaultTokenAllocation: 0,
          vaultType: 'WTON-TOS LP Reward',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 6,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Liquidity Incentive',
          vaultTokenAllocation: 0,
          vaultType: 'Liquidity Incentive',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 7,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Ecosystem',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 8,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Team',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
      ],
      website: '',
    },
    '-NisCDprNdw6aLetygAr': {
      description: '<p>dsdsvxczs</p>',
      isAllDeployed: false,
      isSimplified: true,
      isTokenDeployed: false,
      isTokenDeployedErr: false,
      owner: '0xece893de6E5d9Cf91dBDba25b4eb2A76FB436c67',
      ownerAddress: '0xece893de6E5d9Cf91dBDba25b4eb2A76FB436c67',
      projectName: '',
      projectTokenPrice: 0,
      salePrice: 0,
      sector: 'Simple',
      tokenAddress: '',
      tokenName: '',
      tokenOwnerAccount: '0xece893de6E5d9Cf91dBDba25b4eb2A76FB436c67',
      tokenSymbol: '',
      tokenSymbolImage: '',
      tokenType: 'A',
      tosPrice: 0,
      totalTokenAllocation: 0,
      vaults: [
        {
          addressForReceiving: '',
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 0,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          publicRound1: 1700682420,
          publicRound1End: 1700855220,
          publicRound2: 1701892020,
          publicRound2End: 1702324020,
          snapshot: 1700380018,
          stosTier: {
            fourTier: {
              requiredStos: 6000,
            },
            oneTier: {
              requiredStos: 600,
            },
            threeTier: {
              requiredStos: 2200,
            },
            twoTier: {
              requiredStos: 1200,
            },
          },
          tokenAllocationForLiquidity: 10,
          vaultName: 'Public',
          vaultTokenAllocation: 0,
          vaultType: 'Public',
          whitelist: 1700380019,
          whitelistEnd: 1700552819,
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 1,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Initial Liquidity',
          vaultTokenAllocation: 0,
          vaultType: 'Initial Liquidity',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
              claimTokenAllocation: 50,
            },
            {
              claimRound: 2,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 3,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 4,
              claimTokenAllocation: 16,
            },
          ],
          index: 2,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Vesting',
          vaultTokenAllocation: 0,
          vaultType: 'Vesting',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 3,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TON Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TON Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 4,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TOS Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TOS Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 5,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
          tokenPair: 'WTON-TOS',
          vaultName: 'WTON-TOS LP Reward',
          vaultTokenAllocation: 0,
          vaultType: 'WTON-TOS LP Reward',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 6,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Liquidity Incentive',
          vaultTokenAllocation: 0,
          vaultType: 'Liquidity Incentive',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 7,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Ecosystem',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 8,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Team',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
      ],
    },
    '-NjALDKsrpfF6L1Ymc2u': {
      description: '<p>ttt</p>',
      fundingTarget: 100000,
      isAllDeployed: false,
      isSimplified: true,
      isTokenDeployed: false,
      isTokenDeployedErr: false,
      marketCap: 333333.3333333334,
      owner: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      ownerAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      projectName: 'ttt',
      projectTokenPrice: 65.13,
      salePrice: 65.13,
      sector: 'Simple',
      stablePrice: 0.033333,
      tokenAddress: '',
      tokenName: 'ttt',
      tokenOwnerAccount: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      tokenSymbol: 'ttt',
      tokenSymbolImage: '',
      tokenType: 'A',
      tosPrice: 58.1,
      totalSupply: 10000000,
      totalTokenAllocation: 10000000,
      vaults: [
        {
          addressForReceiving: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1701651650,
              claimTokenAllocation: 750000,
            },
            {
              claimRound: 2,
              claimTime: 1709427650,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 3,
              claimTime: 1717203650,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 4,
              claimTime: 1724979650,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 5,
              claimTime: 1732755650,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 6,
              claimTime: 1740531650,
              claimTokenAllocation: 375000,
            },
            {
              claimRound: 6,
              claimTime: 1748307650,
              claimTokenAllocation: 375000,
            },
          ],
          claimStart: 1701651650,
          hardCap: 23028.2,
          index: 0,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          publicRound1: 1700960449,
          publicRound1Allocation: 1500000,
          publicRound1End: 1701133249,
          publicRound2: 1701219649,
          publicRound2Allocation: 1500000,
          publicRound2End: 1701651649,
          snapshot: 1700701247,
          stosTier: {
            fourTier: {
              allocatedToken: 900000,
              requiredStos: 6000,
            },
            oneTier: {
              allocatedToken: 90000,
              requiredStos: 600,
            },
            threeTier: {
              allocatedToken: 330000,
              requiredStos: 2200,
            },
            twoTier: {
              allocatedToken: 180000,
              requiredStos: 1200,
            },
          },
          tokenAllocationForLiquidity: 10,
          vaultName: 'Public',
          vaultTokenAllocation: 3000000,
          vaultType: 'Public',
          whitelist: 1700701248,
          whitelistEnd: 1700874048,
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1701651650,
              claimTokenAllocation: 300000,
            },
          ],
          index: 1,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          startTime: 1701651650,
          tokenPair: 'ttt-TOS',
          vaultName: 'Initial Liquidity',
          vaultTokenAllocation: 300000,
          vaultType: 'Initial Liquidity',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1701651650,
              claimTokenAllocation: 40,
            },
            {
              claimRound: 2,
              claimTime: 1732755650,
              claimTokenAllocation: 20,
            },
            {
              claimRound: 3,
              claimTime: 1763859650,
              claimTokenAllocation: 20,
            },
            {
              claimRound: 4,
              claimTime: 1794963650,
              claimTokenAllocation: 20,
            },
          ],
          index: 2,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Vesting',
          vaultTokenAllocation: 0,
          vaultType: 'Vesting',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1701651650,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 2,
              claimTime: 1717203650,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 3,
              claimTime: 1732755650,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 4,
              claimTime: 1748307650,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 5,
              claimTime: 1763859650,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 6,
              claimTime: 1779411650,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 7,
              claimTime: 1794963650,
              claimTokenAllocation: 17858,
            },
          ],
          index: 3,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TON Staker',
          vaultTokenAllocation: 125000,
          vaultType: 'TON Staker',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1701651650,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 2,
              claimTime: 1717203650,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 3,
              claimTime: 1732755650,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 4,
              claimTime: 1748307650,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 5,
              claimTime: 1763859650,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 6,
              claimTime: 1779411650,
              claimTokenAllocation: 17857,
            },
            {
              claimRound: 7,
              claimTime: 1794963650,
              claimTokenAllocation: 17858,
            },
          ],
          index: 4,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TOS Staker',
          vaultTokenAllocation: 125000,
          vaultType: 'TOS Staker',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1701651650,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 2,
              claimTime: 1704243650,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 3,
              claimTime: 1706835650,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 4,
              claimTime: 1709427650,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 5,
              claimTime: 1712019650,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 6,
              claimTime: 1714611650,
              claimTokenAllocation: 35714,
            },
            {
              claimRound: 6,
              claimTime: 1794963650,
              claimTokenAllocation: 35716,
            },
          ],
          index: 5,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
          tokenPair: 'WTON-TOS',
          vaultName: 'WTON-TOS LP Reward',
          vaultTokenAllocation: 250000,
          vaultType: 'WTON-TOS LP Reward',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1701651650,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 2,
              claimTime: 1709427650,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 3,
              claimTime: 1717203650,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 4,
              claimTime: 1724979650,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 5,
              claimTime: 1732755650,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 6,
              claimTime: 1740531650,
              claimTokenAllocation: 171429,
            },
            {
              claimRound: 6,
              claimTime: 1748307650,
              claimTokenAllocation: 171426,
            },
          ],
          index: 6,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          tokenPair: 'ttt-TOS',
          vaultName: 'Liquidity Incentive',
          vaultTokenAllocation: 1200000,
          vaultType: 'Liquidity Incentive',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1701651650,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 2,
              claimTime: 1717203650,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 3,
              claimTime: 1732755650,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 4,
              claimTime: 1748307650,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 5,
              claimTime: 1763859650,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 6,
              claimTime: 1779411650,
              claimTokenAllocation: 500000,
            },
            {
              claimRound: 6,
              claimTime: 1794963650,
              claimTokenAllocation: 500000,
            },
          ],
          index: 7,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Ecosystem',
          vaultTokenAllocation: 3500000,
          vaultType: 'C',
        },
        {
          adminAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
          claim: [
            {
              claimRound: 1,
              claimTime: 1735347650,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 2,
              claimTime: 1750899650,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 3,
              claimTime: 1766451650,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 4,
              claimTime: 1782003650,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 5,
              claimTime: 1797555650,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 6,
              claimTime: 1813107650,
              claimTokenAllocation: 214286,
            },
            {
              claimRound: 6,
              claimTime: 1826067650,
              claimTokenAllocation: 214284,
            },
          ],
          index: 8,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Team',
          vaultTokenAllocation: 1500000,
          vaultType: 'C',
        },
      ],
    },
    '-NjucHNWYlpxxfj5FWyt': {
      description: '<p>tttt</p>',
      discord: '',
      isAllDeployed: false,
      isSimplified: false,
      isTokenDeployed: false,
      isTokenDeployedErr: false,
      medium: '',
      owner: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      ownerAddress: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      projectName: 'tttt',
      projectTokenPrice: 0,
      salePrice: 0,
      sector: 'Social',
      telegram: '',
      tokenAddress: '',
      tokenName: 'ttt',
      tokenOwnerAccount: '0x5da0A50c04e4d8DC07740b5C66bc2250566883C2',
      tokenSymbol: 'ttt',
      tokenSymbolImage: '',
      tokenType: 'A',
      tosPrice: 0,
      totalSupply: '10000000',
      totalTokenAllocation: 0,
      twitter: '',
      vaults: [
        {
          addressForReceiving: '',
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 0,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          publicRound1: 1701580720,
          publicRound1End: 1701753520,
          publicRound2: 1701753521,
          publicRound2End: 1702185521,
          snapshot: 1701407917,
          stosTier: {
            fourTier: {
              requiredStos: 6000,
            },
            oneTier: {
              requiredStos: 600,
            },
            threeTier: {
              requiredStos: 2200,
            },
            twoTier: {
              requiredStos: 1200,
            },
          },
          tokenAllocationForLiquidity: 10,
          vaultName: 'Public',
          vaultTokenAllocation: 0,
          vaultType: 'Public',
          whitelist: 1701407918,
          whitelistEnd: 1701580718,
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 1,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Initial Liquidity',
          vaultTokenAllocation: 0,
          vaultType: 'Initial Liquidity',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
              claimTokenAllocation: 50,
            },
            {
              claimRound: 2,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 3,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 4,
              claimTokenAllocation: 16,
            },
          ],
          index: 2,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Vesting',
          vaultTokenAllocation: 0,
          vaultType: 'Vesting',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 3,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TON Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TON Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 4,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TOS Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TOS Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 5,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
          tokenPair: 'WTON-TOS',
          vaultName: 'WTON-TOS LP Reward',
          vaultTokenAllocation: 0,
          vaultType: 'WTON-TOS LP Reward',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 6,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Liquidity Incentive',
          vaultTokenAllocation: 0,
          vaultType: 'Liquidity Incentive',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 7,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Ecosystem',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 8,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Team',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
      ],
      website: '',
    },
    '-NkZlRJolJO-4rRLRQjc': {
      description: '<p>description</p>',
      isAllDeployed: false,
      isSimplified: true,
      isTokenDeployed: false,
      isTokenDeployedErr: false,
      owner: '0x6E115062B13375d1E5B16E5Deb4b3C30051D6161',
      ownerAddress: '0x6E115062B13375d1E5B16E5Deb4b3C30051D6161',
      projectName: 'project',
      projectTokenPrice: 0,
      salePrice: 0,
      sector: 'Simple',
      tokenAddress: '',
      tokenName: 'pro',
      tokenOwnerAccount: '0x6E115062B13375d1E5B16E5Deb4b3C30051D6161',
      tokenSymbol: 'pro',
      tokenSymbolImage: '',
      tokenType: 'A',
      tosPrice: 0,
      totalTokenAllocation: 0,
      vaults: [
        {
          addressForReceiving: '',
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 0,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          publicRound1: 1705916573,
          publicRound1End: 1706089373,
          publicRound2: 1706780573,
          publicRound2End: 1707212573,
          snapshot: 1704102171,
          stosTier: {
            fourTier: {
              requiredStos: 6000,
            },
            oneTier: {
              requiredStos: 600,
            },
            threeTier: {
              requiredStos: 2200,
            },
            twoTier: {
              requiredStos: 1200,
            },
          },
          tokenAllocationForLiquidity: 10,
          vaultName: 'Public',
          vaultTokenAllocation: 0,
          vaultType: 'Public',
          whitelist: 1704102172,
          whitelistEnd: 1704274972,
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 1,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Initial Liquidity',
          vaultTokenAllocation: 0,
          vaultType: 'Initial Liquidity',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
              claimTokenAllocation: 50,
            },
            {
              claimRound: 2,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 3,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 4,
              claimTokenAllocation: 16,
            },
          ],
          index: 2,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Vesting',
          vaultTokenAllocation: 0,
          vaultType: 'Vesting',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 3,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TON Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TON Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 4,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TOS Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TOS Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 5,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
          tokenPair: 'WTON-TOS',
          vaultName: 'WTON-TOS LP Reward',
          vaultTokenAllocation: 0,
          vaultType: 'WTON-TOS LP Reward',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 6,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Liquidity Incentive',
          vaultTokenAllocation: 0,
          vaultType: 'Liquidity Incentive',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 7,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Ecosystem',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 8,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Team',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
      ],
    },
    '-Nkwi4iX_Ia-LUuaE2Fq': {
      description: '<p>1</p>',
      discord: '',
      isAllDeployed: false,
      isSimplified: false,
      isTokenDeployed: false,
      isTokenDeployedErr: false,
      medium: '',
      owner: '0xD0653837bEeC6BC9dc8f7dC12D8b0a0FE3C9f250',
      ownerAddress: '0xD0653837bEeC6BC9dc8f7dC12D8b0a0FE3C9f250',
      projectName: '1',
      projectTokenPrice: 0,
      salePrice: 0,
      sector: 'Defi',
      telegram: '',
      tokenAddress: '',
      tokenName: '1',
      tokenOwnerAccount: '0xD0653837bEeC6BC9dc8f7dC12D8b0a0FE3C9f250',
      tokenSymbol: '1',
      tokenSymbolImage: '',
      tokenType: 'A',
      tosPrice: 0,
      totalSupply: '1',
      totalTokenAllocation: 0,
      twitter: '',
      vaults: [
        {
          addressForReceiving: '',
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 0,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          publicRound1: 0,
          publicRound1End: 0,
          publicRound2: 0,
          publicRound2End: 0,
          snapshot: 0,
          stosTier: {
            fourTier: {
              requiredStos: 6000,
            },
            oneTier: {
              requiredStos: 600,
            },
            threeTier: {
              requiredStos: 2200,
            },
            twoTier: {
              requiredStos: 1200,
            },
          },
          tokenAllocationForLiquidity: 10,
          vaultName: 'Public',
          vaultTokenAllocation: 0,
          vaultType: 'Public',
          whitelist: 0,
          whitelistEnd: 0,
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 1,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Initial Liquidity',
          vaultTokenAllocation: 0,
          vaultType: 'Initial Liquidity',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
              claimTokenAllocation: 50,
            },
            {
              claimRound: 2,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 3,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 4,
              claimTokenAllocation: 16,
            },
          ],
          index: 2,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Vesting',
          vaultTokenAllocation: 0,
          vaultType: 'Vesting',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 3,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TON Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TON Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 4,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TOS Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TOS Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 5,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
          tokenPair: 'WTON-TOS',
          vaultName: 'WTON-TOS LP Reward',
          vaultTokenAllocation: 0,
          vaultType: 'WTON-TOS LP Reward',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 6,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Liquidity Incentive',
          vaultTokenAllocation: 0,
          vaultType: 'Liquidity Incentive',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 7,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Ecosystem',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 8,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Team',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
      ],
      website: '',
    },
    '-NkxylYQYY4ECfb4C99-': {
      description: '',
      discord: '',
      isAllDeployed: false,
      isSimplified: false,
      isTokenDeployed: false,
      isTokenDeployedErr: false,
      medium: '',
      owner: '0x8c595DA827F4182bC0E3917BccA8e654DF8223E1',
      ownerAddress: '0x8c595DA827F4182bC0E3917BccA8e654DF8223E1',
      projectName: '1',
      projectTokenPrice: 0,
      salePrice: 0,
      sector: 'Defi',
      telegram: '',
      tokenAddress: '',
      tokenName: '1',
      tokenOwnerAccount: '0x8c595DA827F4182bC0E3917BccA8e654DF8223E1',
      tokenSymbol: '1',
      tokenSymbolImage: '',
      tokenType: 'A',
      tosPrice: 0,
      totalSupply: '1',
      totalTokenAllocation: 0,
      twitter: '',
      vaults: [
        {
          addressForReceiving: '',
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 0,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          publicRound1: 0,
          publicRound1End: 0,
          publicRound2: 0,
          publicRound2End: 0,
          snapshot: 0,
          stosTier: {
            fourTier: {
              requiredStos: 6000,
            },
            oneTier: {
              requiredStos: 600,
            },
            threeTier: {
              requiredStos: 2200,
            },
            twoTier: {
              requiredStos: 1200,
            },
          },
          tokenAllocationForLiquidity: 10,
          vaultName: 'Public',
          vaultTokenAllocation: 0,
          vaultType: 'Public',
          whitelist: 0,
          whitelistEnd: 0,
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 1,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Initial Liquidity',
          vaultTokenAllocation: 0,
          vaultType: 'Initial Liquidity',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
              claimTokenAllocation: 50,
            },
            {
              claimRound: 2,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 3,
              claimTokenAllocation: 17,
            },
            {
              claimRound: 4,
              claimTokenAllocation: 16,
            },
          ],
          index: 2,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Vesting',
          vaultTokenAllocation: 0,
          vaultType: 'Vesting',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 3,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TON Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TON Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 4,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'TOS Staker',
          vaultTokenAllocation: 0,
          vaultType: 'TOS Staker',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 5,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
          tokenPair: 'WTON-TOS',
          vaultName: 'WTON-TOS LP Reward',
          vaultTokenAllocation: 0,
          vaultType: 'WTON-TOS LP Reward',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 6,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Liquidity Incentive',
          vaultTokenAllocation: 0,
          vaultType: 'Liquidity Incentive',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 7,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Ecosystem',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
        {
          adminAddress: '',
          claim: [
            {
              claimRound: 1,
            },
          ],
          index: 8,
          isDeployed: false,
          isDeployedErr: false,
          isMandatory: true,
          isSet: false,
          vaultName: 'Team',
          vaultTokenAllocation: 0,
          vaultType: 'C',
        },
      ],
      website: '',
    },
  },
  status: 200,
  statusText: '',
  headers: {
    'content-length': '101896',
    'content-type': 'application/json; charset=utf-8',
  },
  config: {
    method: 'get',
    headers: {
      Accept: 'application/json, text/plain, */*',
    },
    transformRequest: [null],
    transformResponse: [null],
    timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    transitional: {
      silentJSONParsing: true,
      forcedJSONParsing: true,
      clarifyTimeoutError: false,
    },
  },
  request: {},
};

export const rewardDB = [
  {
    chainId: 1,
    poolName: 'TOS / WETH',
    poolAddress: '0x2ad99c938471770da0cd60e08eaf29ebff67a92a',
    rewardToken: '0x409c4D8cd5d2924b9bc5509230d16a61289c8153',
    incentiveKey: {
      rewardToken: '0x409c4D8cd5d2924b9bc5509230d16a61289c8153',
      pool: '0x2ad99c938471770da0cd60e08eaf29ebff67a92a',
      startTime: 1638801000,
      endTime: 1641430800,
      refundee: '0x0496B93040E1c7931C8f9b7D1c57787ceb6485d4',
    },
    creator: '0x0496b93040e1c7931c8f9b7d1c57787ceb6485d4',
    startTime: 1638801000,
    endTime: 1641430800,
    allocatedReward: '413750000000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WTON',
    poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
    rewardToken: '0x409c4D8cd5d2924b9bc5509230d16a61289c8153',
    incentiveKey: {
      rewardToken: '0x409c4D8cd5d2924b9bc5509230d16a61289c8153',
      pool: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      startTime: 1638752400,
      endTime: 1641430800,
      refundee: '0x0496B93040E1c7931C8f9b7D1c57787ceb6485d4',
    },
    creator: '0x0496b93040e1c7931c8f9b7d1c57787ceb6485d4',
    startTime: 1638752400,
    endTime: 1641430800,
    allocatedReward: '187500000000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WTON',
    poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
    rewardToken: '0x0e498afce58de8651b983f136256fa3b8d9703bc',
    incentiveKey: {
      rewardToken: '0x0e498afce58de8651b983f136256fa3b8d9703bc',
      pool: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      startTime: 1638752400,
      endTime: 1641430800,
      refundee: '0xc575848f69c710da33a978384114010bdb15f4db',
    },
    creator: '0xc575848f69c710da33a978384114010bdb15f4db',
    startTime: 1638752400,
    endTime: 1641430800,
    allocatedReward: '682870370000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'DOC / TOS',
    poolAddress: '0x369bca127b8858108536b71528ab3befa1deb6fc',
    rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
    incentiveKey: {
      rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
      pool: '0x369bca127b8858108536b71528ab3befa1deb6fc',
      startTime: 1638799200,
      endTime: 1641430800,
      refundee: '0xc575848f69C710dA33A978384114010bdb15f4db',
    },
    creator: '0xc575848f69c710da33a978384114010bdb15f4db',
    startTime: 1638799200,
    endTime: 1641430800,
    allocatedReward: '2731481480000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'WETH / WTON',
    poolAddress: '0xc29271e3a68a7647fd1399298ef18feca3879f59',
    rewardToken: '0x2be5e8c109e2197D077D13A82dAead6a9b3433C5',
    incentiveKey: {
      rewardToken: '0x2be5e8c109e2197D077D13A82dAead6a9b3433C5',
      pool: '0xc29271e3a68a7647fd1399298ef18feca3879f59',
      startTime: 1639098000,
      endTime: 1641776400,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1639098000,
    endTime: 1641776400,
    allocatedReward: '70000000000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WETH',
    poolAddress: '0x2ad99c938471770da0cd60e08eaf29ebff67a92a',
    rewardToken: '0x2be5e8c109e2197D077D13A82dAead6a9b3433C5',
    incentiveKey: {
      rewardToken: '0x2be5e8c109e2197D077D13A82dAead6a9b3433C5',
      pool: '0x2ad99c938471770da0cd60e08eaf29ebff67a92a',
      startTime: 1639098000,
      endTime: 1641776400,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1639098000,
    endTime: 1641776400,
    allocatedReward: '10000000000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WTON',
    poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
    rewardToken: '0x2be5e8c109e2197d077d13a82daead6a9b3433c5',
    incentiveKey: {
      rewardToken: '0x2be5e8c109e2197d077d13a82daead6a9b3433c5',
      pool: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      startTime: 1639098000,
      endTime: 1641776400,
      refundee: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1639098000,
    endTime: 1641776400,
    allocatedReward: '20000000000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WTON',
    poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
    rewardToken: '0x409c4D8cd5d2924b9bc5509230d16a61289c8153',
    incentiveKey: {
      rewardToken: '0x409c4D8cd5d2924b9bc5509230d16a61289c8153',
      pool: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      startTime: 1640055599,
      endTime: 1642733999,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1640055599,
    endTime: 1642733999,
    allocatedReward: '226484020000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WTON',
    poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
    rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
    incentiveKey: {
      rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
      pool: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      startTime: 1640163600,
      endTime: 1642755600,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1640163600,
    endTime: 1642755600,
    allocatedReward: '67567560000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / AURA',
    poolAddress: '0xbddd3a50bd2afd27aed05cc9fe1c8d67fcaa3218',
    rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
    incentiveKey: {
      rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
      pool: '0xbddd3a50bd2afd27aed05cc9fe1c8d67fcaa3218',
      startTime: 1640163600,
      endTime: 1642755600,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1640163600,
    endTime: 1642755600,
    allocatedReward: '1700000000000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / AURA',
    poolAddress: '0xbddd3a50bd2afd27aed05cc9fe1c8d67fcaa3218',
    rewardToken: '0xc4A11aaf6ea915Ed7Ac194161d2fC9384F15bff2',
    incentiveKey: {
      rewardToken: '0xc4A11aaf6ea915Ed7Ac194161d2fC9384F15bff2',
      pool: '0xbddd3a50bd2afd27aed05cc9fe1c8d67fcaa3218',
      startTime: 1640401140,
      endTime: 1642755600,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1640401140,
    endTime: 1642755600,
    allocatedReward: '50000000000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'DOC / TOS',
    poolAddress: '0x369bca127b8858108536b71528ab3befa1deb6fc',
    rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
    incentiveKey: {
      rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
      pool: '0x369bca127b8858108536b71528ab3befa1deb6fc',
      startTime: 1641430800,
      endTime: 1644048000,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1641430800,
    endTime: 1644048000,
    allocatedReward: '1388888880000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WTON',
    poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
    rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
    incentiveKey: {
      rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
      pool: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      startTime: 1641430800,
      endTime: 1644048000,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1641430800,
    endTime: 1644048000,
    allocatedReward: '347222220000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / AURA',
    poolAddress: '0xbddd3a50bd2afd27aed05cc9fe1c8d67fcaa3218',
    rewardToken: '0xc4A11aaf6ea915Ed7Ac194161d2fC9384F15bff2',
    incentiveKey: {
      rewardToken: '0xc4A11aaf6ea915Ed7Ac194161d2fC9384F15bff2',
      pool: '0xbddd3a50bd2afd27aed05cc9fe1c8d67fcaa3218',
      startTime: 1641891600,
      endTime: 1644570000,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1641891600,
    endTime: 1644570000,
    allocatedReward: '55000000000000000000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / AURA',
    poolAddress: '0xbddd3a50bd2afd27aed05cc9fe1c8d67fcaa3218',
    rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
    incentiveKey: {
      rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
      pool: '0xbddd3a50bd2afd27aed05cc9fe1c8d67fcaa3218',
      startTime: 1642757400,
      endTime: 1645520400,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1642757400,
    endTime: 1645520400,
    allocatedReward: '400000000000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WTON',
    poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
    rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
    incentiveKey: {
      rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
      pool: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      startTime: 1642757400,
      endTime: 1645520400,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1642757400,
    endTime: 1645520400,
    allocatedReward: '67567560000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'WETH / WTON',
    poolAddress: '0xc29271e3a68a7647fd1399298ef18feca3879f59',
    rewardToken: '0x2be5e8c109e2197D077D13A82dAead6a9b3433C5',
    incentiveKey: {
      rewardToken: '0x2be5e8c109e2197D077D13A82dAead6a9b3433C5',
      pool: '0xc29271e3a68a7647fd1399298ef18feca3879f59',
      startTime: 1642757400,
      endTime: 1643965200,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1642757400,
    endTime: 1643965200,
    allocatedReward: '35000000000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WTON',
    poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
    rewardToken: '0x2be5e8c109e2197D077D13A82dAead6a9b3433C5',
    incentiveKey: {
      rewardToken: '0x2be5e8c109e2197D077D13A82dAead6a9b3433C5',
      pool: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      startTime: 1642757400,
      endTime: 1643965200,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1642757400,
    endTime: 1643965200,
    allocatedReward: '10000000000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WETH',
    poolAddress: '0x2ad99c938471770da0cd60e08eaf29ebff67a92a',
    rewardToken: '0x2be5e8c109e2197D077D13A82dAead6a9b3433C5',
    incentiveKey: {
      rewardToken: '0x2be5e8c109e2197D077D13A82dAead6a9b3433C5',
      pool: '0x2ad99c938471770da0cd60e08eaf29ebff67a92a',
      startTime: 1642757400,
      endTime: 1643965200,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1642757400,
    endTime: 1643965200,
    allocatedReward: '5000000000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'DOC / TOS',
    poolAddress: '0x369bca127b8858108536b71528ab3befa1deb6fc',
    rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
    incentiveKey: {
      rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
      pool: '0x369bca127b8858108536b71528ab3befa1deb6fc',
      startTime: 1644404400,
      endTime: 1646823600,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1644404400,
    endTime: 1646823600,
    allocatedReward: '1388888880000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WTON',
    poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
    rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
    incentiveKey: {
      rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
      pool: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      startTime: 1644404400,
      endTime: 1646823600,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1644404400,
    endTime: 1646823600,
    allocatedReward: '347222220000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / AURA',
    poolAddress: '0xbddd3a50bd2afd27aed05cc9fe1c8d67fcaa3218',
    rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
    incentiveKey: {
      rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
      pool: '0xbddd3a50bd2afd27aed05cc9fe1c8d67fcaa3218',
      startTime: 1645524000,
      endTime: 1647939600,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1645524000,
    endTime: 1647939600,
    allocatedReward: '400000000000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WTON',
    poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
    rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
    incentiveKey: {
      rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
      pool: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      startTime: 1645524000,
      endTime: 1647939600,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1645524000,
    endTime: 1647939600,
    allocatedReward: '67567560000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'DOC / WETH',
    poolAddress: '0xda3cc73170aa5bb7c0a9588e7690299df568d53d',
    rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
    incentiveKey: {
      rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
      pool: '0xda3cc73170aa5bb7c0a9588e7690299df568d53d',
      startTime: 1646823600,
      endTime: 1649059200,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1646823600,
    endTime: 1649059200,
    allocatedReward: '416666660000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'DOC / TOS',
    poolAddress: '0x369bca127b8858108536b71528ab3befa1deb6fc',
    rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
    incentiveKey: {
      rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
      pool: '0x369bca127b8858108536b71528ab3befa1deb6fc',
      startTime: 1646823600,
      endTime: 1649059200,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1646823600,
    endTime: 1649059200,
    allocatedReward: '972222220000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WTON',
    poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
    rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
    incentiveKey: {
      rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
      pool: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      startTime: 1646823600,
      endTime: 1649059200,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1646823600,
    endTime: 1649059200,
    allocatedReward: '347222220000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / AURA',
    poolAddress: '0xbddd3a50bd2afd27aed05cc9fe1c8d67fcaa3218',
    rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
    incentiveKey: {
      rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
      pool: '0xbddd3a50bd2afd27aed05cc9fe1c8d67fcaa3218',
      startTime: 1647941400,
      endTime: 1650704400,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1647941400,
    endTime: 1650704400,
    allocatedReward: '400000000000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WTON',
    poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
    rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
    incentiveKey: {
      rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
      pool: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      startTime: 1647941400,
      endTime: 1650704400,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1647941400,
    endTime: 1650704400,
    allocatedReward: '67567560000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'DOC / TOS',
    poolAddress: '0x369bca127b8858108536b71528ab3befa1deb6fc',
    rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
    incentiveKey: {
      rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
      pool: '0x369bca127b8858108536b71528ab3befa1deb6fc',
      startTime: 1649178000,
      endTime: 1651942800,
      refundee: '0x986D9bB496AbD602ffbab9291a2621834f0f03a3',
    },
    creator: '0x986d9bb496abd602ffbab9291a2621834f0f03a3',
    startTime: 1649178000,
    endTime: 1651942800,
    allocatedReward: '972222220000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WTON',
    poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
    rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
    incentiveKey: {
      rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
      pool: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      startTime: 1649149200,
      endTime: 1651914000,
      refundee: '0x986D9bB496AbD602ffbab9291a2621834f0f03a3',
    },
    creator: '0x986d9bb496abd602ffbab9291a2621834f0f03a3',
    startTime: 1649149200,
    endTime: 1651914000,
    allocatedReward: '347222220000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'DOC / WETH',
    poolAddress: '0xda3cc73170aa5bb7c0a9588e7690299df568d53d',
    rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
    incentiveKey: {
      rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
      pool: '0xda3cc73170aa5bb7c0a9588e7690299df568d53d',
      startTime: 1649149200,
      endTime: 1651914000,
      refundee: '0x986D9bB496AbD602ffbab9291a2621834f0f03a3',
    },
    creator: '0x986d9bb496abd602ffbab9291a2621834f0f03a3',
    startTime: 1649149200,
    endTime: 1651914000,
    allocatedReward: '416666660000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / AURA',
    poolAddress: '0xbddd3a50bd2afd27aed05cc9fe1c8d67fcaa3218',
    rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
    incentiveKey: {
      rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
      pool: '0xbddd3a50bd2afd27aed05cc9fe1c8d67fcaa3218',
      startTime: 1650704400,
      endTime: 1653382800,
      refundee: '0x47462B8062F87F63D84EBB9E0d931d38bD3F6F75',
    },
    creator: '0x47462b8062f87f63d84ebb9e0d931d38bd3f6f75',
    startTime: 1650704400,
    endTime: 1653382800,
    allocatedReward: '400000000000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WTON',
    poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
    rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
    incentiveKey: {
      rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
      pool: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      startTime: 1650704400,
      endTime: 1653382800,
      refundee: '0x47462B8062F87F63D84EBB9E0d931d38bD3F6F75',
    },
    creator: '0x47462b8062f87f63d84ebb9e0d931d38bd3f6f75',
    startTime: 1650704400,
    endTime: 1653382800,
    allocatedReward: '67567560000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'DOC / TOS',
    poolAddress: '0x369bca127b8858108536b71528ab3befa1deb6fc',
    rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
    incentiveKey: {
      rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
      pool: '0x369bca127b8858108536b71528ab3befa1deb6fc',
      startTime: 1651914000,
      endTime: 1654506000,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1651914000,
    endTime: 1654506000,
    allocatedReward: '972222220000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WTON',
    poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
    rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
    incentiveKey: {
      rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
      pool: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      startTime: 1651914000,
      endTime: 1654506000,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1651914000,
    endTime: 1654506000,
    allocatedReward: '347222220000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'DOC / WETH',
    poolAddress: '0xda3cc73170aa5bb7c0a9588e7690299df568d53d',
    rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
    incentiveKey: {
      rewardToken: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
      pool: '0xda3cc73170aa5bb7c0a9588e7690299df568d53d',
      startTime: 1651914000,
      endTime: 1654506000,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1651914000,
    endTime: 1654506000,
    allocatedReward: '416666660000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / AURA',
    poolAddress: '0xbddd3a50bd2afd27aed05cc9fe1c8d67fcaa3218',
    rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
    incentiveKey: {
      rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
      pool: '0xbddd3a50bd2afd27aed05cc9fe1c8d67fcaa3218',
      startTime: 1653382800,
      endTime: 1655974800,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1653382800,
    endTime: 1655974800,
    allocatedReward: '400000000000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WTON',
    poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
    rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
    incentiveKey: {
      rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
      pool: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      startTime: 1653382800,
      endTime: 1655974800,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1653382800,
    endTime: 1655974800,
    allocatedReward: '67567560000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / AURA',
    poolAddress: '0xbddd3a50bd2afd27aed05cc9fe1c8d67fcaa3218',
    rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
    incentiveKey: {
      rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
      pool: '0xbddd3a50bd2afd27aed05cc9fe1c8d67fcaa3218',
      startTime: 1655974800,
      endTime: 1658566800,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1655974800,
    endTime: 1658566800,
    allocatedReward: '400000000000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WTON',
    poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
    rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
    incentiveKey: {
      rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
      pool: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      startTime: 1655974800,
      endTime: 1658566800,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1655974800,
    endTime: 1658566800,
    allocatedReward: '67567560000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WTON',
    poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
    rewardToken: '0xE1B0630D7649CdF503eABc2b6423227Be9605247',
    incentiveKey: {
      rewardToken: '0xE1B0630D7649CdF503eABc2b6423227Be9605247',
      pool: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      startTime: 1656224684,
      endTime: 1658816684,
      refundee: '0xA31945830C5a6B225A81962a10E78D2e3793D72D',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1656224684,
    endTime: 1658816684,
    allocatedReward: '6756000000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / LYDA',
    poolAddress: '0x3ae1e82f20c134867514ecd1e615856b312fb685',
    rewardToken: '0xe1b0630d7649cdf503eabc2b6423227be9605247',
    incentiveKey: {
      rewardToken: '0xe1b0630d7649cdf503eabc2b6423227be9605247',
      pool: '0x3ae1e82f20c134867514ecd1e615856b312fb685',
      startTime: 1656224666,
      endTime: 1658816666,
      refundee: '0x45d08f522bf2b6455fe7eef0f4adf865d76ead08',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1656224666,
    endTime: 1658816666,
    allocatedReward: '50000000000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WTON',
    poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
    rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
    incentiveKey: {
      rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
      pool: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      startTime: 1658736000,
      endTime: 1661414400,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1658736000,
    endTime: 1661414400,
    allocatedReward: '67567560000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'WTON / TOS',
    poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
    rewardToken: '0xE1B0630D7649CdF503eABc2b6423227Be9605247',
    incentiveKey: {
      rewardToken: '0xE1B0630D7649CdF503eABc2b6423227Be9605247',
      pool: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      startTime: 1660701731,
      endTime: 1663293731,
      refundee: '0xA31945830C5a6B225A81962a10E78D2e3793D72D',
    },
    creator: '0x07c41d80181db0bd0d21cc2bb61cbc40430b94dc',
    startTime: 1660701731,
    endTime: 1663293731,
    allocatedReward: '6756000000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / LYDA',
    poolAddress: '0x3ae1e82f20c134867514ecd1e615856b312fb685',
    rewardToken: '0xe1b0630d7649cdf503eabc2b6423227be9605247',
    incentiveKey: {
      rewardToken: '0xe1b0630d7649cdf503eabc2b6423227be9605247',
      pool: '0x3ae1e82f20c134867514ecd1e615856b312fb685',
      startTime: 1660378515,
      endTime: 1662970515,
      refundee: '0x45d08f522bf2b6455fe7eef0f4adf865d76ead08',
    },
    creator: '0x7ba6183bb6f346a670217f8bb7d3de90d7ff9147',
    startTime: 1660378515,
    endTime: 1662970515,
    allocatedReward: '50000000000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / WTON',
    poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
    rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
    incentiveKey: {
      rewardToken: '0xaEC59E5b4f8DbF513e260500eA96EbA173F74149',
      pool: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      startTime: 1661414400,
      endTime: 1664092800,
      refundee: '0x340C44089bc45F86060922d2d89eFee9e0CDF5c7',
    },
    creator: '0x340c44089bc45f86060922d2d89efee9e0cdf5c7',
    startTime: 1661414400,
    endTime: 1664092800,
    allocatedReward: '67567560000000000000000',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / LYDA',
    poolAddress: '0x3ae1e82f20c134867514ecd1e615856b312fb685',
    rewardToken: '0xe1b0630d7649cdf503eabc2b6423227be9605247',
    incentiveKey: {
      rewardToken: '0xe1b0630d7649cdf503eabc2b6423227be9605247',
      pool: '0x3ae1e82f20c134867514ecd1e615856b312fb685',
      startTime: 1663384727,
      endTime: 1665976727,
      refundee: '0x45d08f522bf2b6455fe7eef0f4adf865d76ead08',
    },
    creator: '0x7ba6183bb6f346a670217f8bb7d3de90d7ff9147',
    startTime: 1663384727,
    endTime: 1665976727,
    allocatedReward: '64756294273470763826823',
    numStakers: 0,
    status: 'open',
  },
  {
    chainId: 1,
    poolName: 'TOS / LYDA',
    poolAddress: '0x3ae1e82f20c134867514ecd1e615856b312fb685',
    rewardToken: '0xe1b0630d7649cdf503eabc2b6423227be9605247',
    incentiveKey: {
      rewardToken: '0xe1b0630d7649cdf503eabc2b6423227be9605247',
      pool: '0x3ae1e82f20c134867514ecd1e615856b312fb685',
      startTime: 1671617339,
      endTime: 1674209339,
      refundee: '0x45d08f522bf2b6455fe7eef0f4adf865d76ead08',
    },
    creator: '0x6fac733457d06c45096bbf3cad530cf5339b6441',
    startTime: 1671617339,
    endTime: 1674209339,
    allocatedReward: '178862652607062527681476',
    numStakers: 0,
    status: 'open',
  },
];

export const localDumpRewardData = {
  success: true,
  message: '',
  query: {
    del: {
      $ne: true,
    },
    chainId: '1',
  },
  counts: 7,
  page: 1,
  pagesize: 100,
  sort: -1,
  datas: [
    {
      chainId: 1,
      poolAddress: '0x369bca127b8858108536b71528ab3befa1deb6fc',
      poolName: 'DOC/TOS',
      token0Address: '0x0e498afce58dE8651B983F136256fA3b8d9703bc',
      token1Address: '0x409c4D8cd5d2924b9bc5509230d16a61289c8153',
      token0Image:
        'https://tonstarter-symbols.s3.ap-northeast-2.amazonaws.com/doc-symbol%403x.png',
      token1Image:
        'https://tonstarter-symbols.s3.ap-northeast-2.amazonaws.com/tos-symbol%403x.png',
      feeTier: 3000,
      numReward: 0,
      token1Price: '0.6870668497226844',
      token0Price: '0.000046203845532091626',
    },
    {
      chainId: 1,
      poolAddress: '0x2ad99c938471770da0cd60e08eaf29ebff67a92a',
      poolName: 'TOS/ETH',
      token0Address: '0x409c4D8cd5d2924b9bc5509230d16a61289c8153',
      token1Address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
      token0Image:
        'https://tonstarter-symbols.s3.ap-northeast-2.amazonaws.com/tos-symbol%403x.png',
      token1Image:
        'https://tonstarter-symbols.s3.ap-northeast-2.amazonaws.com/eth-symbol%403x.png',
      feeTier: 3000,
      numReward: 0,
      token0Price: '0.6870668497226844',
      token1Price: '2676.75',
    },
    {
      chainId: 1,
      poolAddress: '0xc29271e3a68a7647fd1399298ef18feca3879f59',
      poolName: 'ETH/WTON',
      token0Address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
      token1Address: '0xc4A11aaf6ea915Ed7Ac194161d2fC9384F15bff2',
      token0Image:
        'https://tonstarter-symbols.s3.ap-northeast-2.amazonaws.com/eth-symbol%403x.png',
      token1Image:
        'https://tonstarter-symbols.s3.ap-northeast-2.amazonaws.com/wton-symbol%403x.png',
      feeTier: 3000,
      numReward: 0,
      token0Price: '2676.75',
      token1Price: '1.12575',
    },
    {
      chainId: 1,
      poolAddress: '0x1c0ce9aaa0c12f53df3b4d8d77b82d6ad343b4e4',
      poolName: 'TOS/WTON',
      token0Address: '0x409c4D8cd5d2924b9bc5509230d16a61289c8153',
      token1Address: '0xc4A11aaf6ea915Ed7Ac194161d2fC9384F15bff2',
      token0Image:
        'https://tonstarter-symbols.s3.ap-northeast-2.amazonaws.com/tos-symbol%403x.png',
      token1Image:
        'https://tonstarter-symbols.s3.ap-northeast-2.amazonaws.com/wton-symbol%403x.png',
      feeTier: 3000,
      numReward: 0,
      token1Price: '1.1199999999999999',
      token0Price: '0.6870668497226844',
    },
    {
      chainId: 1,
      poolAddress: '0xbddd3a50bd2afd27aed05cc9fe1c8d67fcaa3218',
      poolName: 'TOS/AURA',
      token0Address: '0x409c4D8cd5d2924b9bc5509230d16a61289c8153',
      token1Address: '0xaec59e5b4f8dbf513e260500ea96eba173f74149',
      token0Image:
        'https://tonstarter-symbols.s3.ap-northeast-2.amazonaws.com/tos-symbol%403x.png',
      token1Image:
        'https://tonstarter-symbols.s3.ap-northeast-2.amazonaws.com/aura-logo-black-big.png',
      feeTier: 3000,
      numReward: 0,
      token1Price: '0.00391086649101487',
      token0Price: '0.6870668497226844',
    },
    {
      chainId: 1,
      poolAddress: '0xda3cc73170aa5bb7c0a9588e7690299df568d53d',
      poolName: 'DOC/ETH',
      token0Address: '0x0e498afce58de8651b983f136256fa3b8d9703bc',
      token1Address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
      token0Image:
        'https://tonstarter-symbols.s3.ap-northeast-2.amazonaws.com/doc-symbol%403x.png',
      token1Image:
        'https://tonstarter-symbols.s3.ap-northeast-2.amazonaws.com/eth-symbol%403x.png',
      feeTier: 3000,
      numReward: 0,
      token1Price: '2676.75',
      token0Price: '7.866852641549787e-36',
    },
    {
      chainId: 1,
      poolAddress: '0x3ae1e82f20c134867514ecd1e615856b312fb685',
      poolName: 'TOS / LYDA',
      token0Address: '0x409c4D8cd5d2924b9bc5509230d16a61289c8153',
      token0Price: '0.6870668497226844',
      token1Address: '0xE1B0630D7649CdF503eABc2b6423227Be9605247',
      token1Price: '0.011776449122132967',
      token0Image:
        'https://tonstarter-symbols.s3.ap-northeast-2.amazonaws.com/tos-symbol%403x.png',
      token1Image: 'https://cdn.imweb.me/thumbnail/20220608/f32f048bccbad.jpg',
      feeTier: 3000,
      numReward: 0,
    },
  ],
};
